
const en = {
  "你主动注销后，我们将停止为你提供产品/服务，根据适用法律的要求删除你的个人信息，或使其匿名化处理":"After you voluntarily cancel, we will stop providing you with products/services, delete your personal information in accordance with applicable laws, or anonymize it for processing.",
  "填写并提交注销申请，工作人员会协助你完成注销。":"Fill out and submit the cancellation application, and the staff will assist you in completing the cancellation.",
    "请求错误(400)": "Request error (400)",
    "未授权，请重新登录(401)": "Unauthorized, please log in again (401)",
    "登录失效": "Login failure",
    "拒绝访问(403)": "Access Denied (403)",
    "请求出错(404)": "Request error (404)",
    "请求超时(408)": "Request timeout (408)",
    "服务器错误(500)": "Server error (500)",
    "服务未实现(501)": "Service not implemented (501)",
    "网络错误(502)": "Network error (502)",
    "服务不可用(503)": "Service unavailable (503)",
    "网络超时(504)": "Network timeout (504)",
    "HTTP版本不受支持(505)": "HTTP version is not supported (505)",
    "服务器错误!": "Server error!",
    "服务器太拥挤了~请您稍后重试": "The server is too crowded~Please try again later",
    "登录失效，请重新登录": "Login failed, please login again",
    "刚刚": "just",
    "分钟前": "Minutes ago",
    "小时前": "Hours ago",
    "天前": "Days ago",
    "个月前": "Months ago",
    "年前": "last year",
    "请先设置你的密码": "Please set your password first",
    "要携带的参数": "Parameters to carry",
    "请用指纹解锁": "",
    "验证失败": "Verification failed",
    "请用FaceID解锁": "",
    "识别成功": "Identification succeeded",
    "首页": "home page",
    "分类": "classification",
    "购物车": "cart",
    "我的": "my",
    "操作成功~": "Operation succeeded~",
    "支付失败": "Payment failed",
    "上传中": "Uploading",
    "上传失败，请重试": "Upload failed, please try again",
    "视频上传失败，请重试": "Video upload failed, please try again",
    "图片上传失败，请重试": "",
    "通知权限开启提醒": "Notification permission enable reminder",
    "您还没有开启通知权限，无法接受到消息通知，是否前往设置？": "You have not opened the notification permission and cannot receive the message notification. Do you want to go to the settings?",
    "直播": "",
    "验证码发送成功": "",
    "请输入手机号": "Please enter your mobile number",
    "请正确输入手机号": "Please enter your phone number correctly",
    "请发送验证码": "",
    "后重新获取": "Reacquire after",
    "提示": "Tips",
    "确定要清除本地缓存？": "Are you sure you want to clear the local cache?",
    "缓存清理完成!": "Cache cleaning completed!",
    "取消支付": "Cancel payment",
    "支付失败,请稍后重试": "Payment failed. Please try again later",
    "请输入账号": "",
    "请正确账号": "",
    "发送中...": "Sending",
    "您有逾期订单未还款，请先还款": "You have an overdue order that has not been repaid, please repay it first",
    "确定删除该评论": "Confirm to delete this comment",
    "可前往至“我的优惠券“中心查看": "You can go to the “My Coupon“ center to view",
    "确定删除该提货人?": "Are you sure to delete the pickup person?",
    "审核被拒绝，请重新提交": "Approval rejected, please resubmit",
    "发现新版本": "New version found",
    "下次再说": "Next time",
    "马上更新": "Update now",
    "已是最新版本": "Is the latest version",
    "已准备好新版本,是否重启体验新版?": "The new version is ready. Do you want to restart and experience the new version?",
    "重启": "restart",
    "取消下载": "Cancel download",
    "下载失败": "Download failed",
    "搜索": "search",
    "定位\/最近访问": "Location\/Recent Visit",
    "月": "month",
    "年": "year",
    "开始": "start",
    "结束": "end",
    "日": "day",
    "一": "one",
    "二": "two",
    "三": "three",
    "四": "four",
    "五": "five",
    "六": "six",
    "星期日": "Sunday",
    "星期一": "Monday",
    "星期二": "Tuesday",
    "星期三": "Wednesday",
    "星期四": "Thursday",
    "星期五": "Friday",
    "星期六": "Saturday",
    "加载中": "Loading",
    "已加载全部数据": "All data loaded",
    "暂无数据": "No data",
    "销量": "sales volume",
    "万": "ten thousand",
    "加载失败": "Load failed",
    "加载中...": "Loading",
    "温馨提示": "reminder",
    "请输入内容~": "Please enter content~",
    "取消": "cancel",
    "确认": "confirm",
    "返回": "return",
    "请输入搜索关键字": "Please enter search keywords",
    "标题": "title",
    "请检查网络，或者前往": "Please check the network, or go to",
    "设置": "set up",
    "点击刷新": "Click Refresh",
    "刷新": "Refresh",
    "哎呀，网络信号丢失": "Alas, the network signal is lost",
    "网络链接成功": "Network link succeeded",
    "无网络链接": "No network link",
    "分享到": "Share to",
    "微信好友": "WeChat friends",
    "二维码海报": "QR code poster",
    "保存到相册": "Save to album",
    "保存图片": "Save Picture",
    "朋友圈": "Wechat Moments",
    "QQ空间": "QQ Zone",
    "QQ好友": "QQ friends",
    "新浪微博": "Sina Weibo",
    "复制链接": "Copy Link",
    "昵称不能为空": "Nickname cannot be empty",
    "复制成功": "Copy succeeded",
    "分享失败": "Sharing failed",
    "海报生成中...": "Generating poster",
    "获取头像信息失败": "Failed to get avatar information",
    "获取商品图片信息失败": "Failed to get product picture information",
    "推荐一个好物给你,请查收": "I recommend a good thing for you. Please check it",
    "获取二维码信息失败": "Failed to obtain QR code information",
    "保存成功": "Save successful",
    "为你推荐": "Recommended for you",
    "上拉显示更多": "Pull up to show more",
    "正在加载...": "Loading",
    "没有更多数据了": "No more data",
    "该商品已售馨": "This product has been sold",
    "该商品最多能购买": "This item can be purchased at most",
    "件": "piece",
    "商品详情": "Product details",
    "预售价": "Presale price",
    "定金": "Deposit",
    "已收藏": "Favorite",
    "收藏": "Collection",
    "库存": "stock",
    "尾款": "balance payment",
    "流程": "technological process",
    "付定金": "pay deposit",
    "付尾款": "Final payment",
    "发货": "deliver goods",
    "规格": "Specifications",
    "送至": "Send to",
    "我的订单": "My order",
    "商品评价": "Commodity evaluation",
    "查看全部": "View All",
    "客服": "Service",
    "分享": "Share",
    "支付定金": "Payment of deposit",
    "商品": "commodity",
    "评价": "appraise",
    "详情": "detailed information",
    "获取详情失败": "Failed to get details",
    "距预售结束": "Until the end of pre-sale",
    "该商品暂无库存": "The product is temporarily out of stock",
    "该商品暂无评论,": "There is no comment on this product,",
    "保存临时二维码失败": "Failed to save temporary QR code",
    "获取分享二维码失败": "Failed to obtain the shared QR code",
    "新品预售": "New product pre-sale",
    "抢": "rob",
    "人拼": "Renpin",
    "单买价": "Single purchase price",
    "这些人刚刚购买成功,可直接参与拼单": "These people have just purchased successfully and can directly participate in the order",
    "还差": "Not good",
    "人拼成": "People put together",
    "去拼单": "To spell out a single",
    "立即抢购": "Buy now",
    "发起拼单": "Initiate order combination",
    "据拼团结束仅剩": "According to the end of the group, only",
    "这是您发起的拼团！": "This is your team!",
    "超值拼单": "Super Value Collage",
    "人拼单成功": "People's Group buy succeeded",
    "马上拼": "go group booking",
    "我的拼单": "My spelling",
    "订单编号": "Order No",
    "拼团中": "In a group",
    "拼团成功": "Team successfully",
    "拼团失败": "Failed to join forces",
    "待付款": "To be paid",
    "已付款": "Paid",
    "已发货": "Shipped",
    "已完成": "Completed",
    "已评价": "Evaluated",
    "售后中": "After sales",
    "售后已完成": "After sales completed",
    "已取消": "Canceled",
    "提交成功,正在为您取消订单": "Successfully submitted, canceling the order for you",
    "全部": "whole",
    "进行中": "have in hand",
    "成功": "success",
    "已免费拿": "Free",
    "价值": "value",
    "据砍价结束仅剩": "According to the end of the bargain, only",
    "继续砍价": "Continue to bargain",
    "点击免单": "Click Free",
    "已选择该商品，开始免费拿": "You have selected this item and start to get it for free",
    "砍价免费拿": "Free of charge",
    "规则": "rule",
    "幸运享免单": "Lucky free",
    "限时兑好礼": "Cash a good gift within a time limit",
    "正在进行中": "In progress",
    "已砍": "Hacked",
    "元": "element",
    "仅差": "Only poor",
    "后结束": "End after",
    "点击免费拿": "Click to get it for free",
    "活动规则": "Activity rules",
    "关闭": "close",
    "免费拿仅差百分之": "There is only a percentage difference between getting free",
    "邀请好友帮砍": "Invite friends to help cut",
    "砍价记录": "Bargain record",
    "使用砍价道具狂砍一刀": "Use the bargaining props to slash",
    "砍掉": "Cut off",
    "我在砍价免费拿": "I'm bargaining for free",
    "借你大刀砍一砍": "I borrow your big knife to cut",
    "恭喜你,砍价成功": "Congratulations, the bargain was successful",
    "我马上就快砍成啦，快来帮我助力吧~": "I will soon be cut into pieces. Come and help me~",
    "你帮砍后,好友砍成概率达": "After you cut, the probability of friends cutting is up to",
    "帮好友砍一刀": "Help your friend cut a knife",
    "帮砍成功": "Help cut successfully",
    "恭喜你!成功挑到喜欢的宝贝": "congratulations! Successfully selected the baby you like",
    "成功砍掉": "Successfully cut off",
    "剩余时间": "Time remaining",
    "免费拿": "Free",
    "自己砍一刀": "Cut yourself",
    "优惠": "Discount",
    "满": "full",
    "可减": "Reducible",
    "使用限制": "Use restrictions",
    "无限制": "unlimited",
    "有效期至": "Valid until",
    "已领取": "Received",
    "立即领取": "Get it now",
    "配送至": "Ship to",
    "发票类型": "Invoice type",
    "普通发票": "Ordinary invoice",
    "抬头类型": "Heading type",
    "个人或事业单位": "Individuals or institutions",
    "企业": "enterprise",
    "发票抬头": "Invoice Header",
    "填写需要开具发票的姓名": "Fill in the name to be invoiced",
    "填写需要开具发票的企业名称": "Fill in the name of the enterprise to be invoiced",
    "税号": "duty paragraph",
    "纳税人识别号": "Taxpayer identification number",
    "开户银行": "Bank of deposit",
    "选填": "Optional",
    "银行账号": "bank account",
    "企业地址": "Business address",
    "企业电话": "Enterprise telephone",
    "发票内容": "Invoice content",
    "明细": "detailed",
    "发票内容将显示详细商品名称与价格信息。": "The invoice content will display detailed product name and price information.",
    "部分商家可能开具发票内容为商品所属类别及价格信息，如有特殊需求，请向商家客服咨询。": "Some merchants may issue invoices containing the category and price information of the goods. If you have special needs, please consult the merchant customer service.",
    "提交": "Submit",
    "请输入发票抬头": "Please enter invoice title",
    "请输入税号": "Please enter the tax number",
    "已选择": "Selected",
    "数量": "quantity",
    "此商品限购": "Limited purchase of this product",
    "加购物车": "Add shopping cart",
    "请先选择规格": "Please select the specification first",
    "共": "common",
    "个": "individual",
    "立即订购": "Order Now",
    "距秒杀结束仅剩": "Only after the second kill",
    "加入购物车成功": "Successfully added to shopping cart",
    "抢购中": "In rush purchase",
    "即将开始": "begin in a minute",
    "距离本场结束还剩": "It's still to be finished",
    "人成功秒杀": "People succeed in second killing",
    "马上抢": "Grab it now",
    "抢光了": "It's gone",
    "提醒我": "Remind me",
    "取消提醒": "Cancel reminder",
    "本场次没有商品哦": "There are no commodities in this session",
    "设置成功,将在开抢前三分钟收到提醒": "Successfully set, will receive a reminder three minutes before the start of the robbery",
    "该功能暂未开发": "This function has not been developed yet",
    "H5不支持推送功能": "H5 does not support push function",
    "秒杀提醒已取消,您可能会抢不到": "The second kill reminder has been canceled. You may not get it",
    "您还没有收货地址,去添加": "You don't have a shipping address yet. Go to add it",
    "商品总额": "Total merchandise",
    "发票": "Invoice",
    "不开发票": "No invoice",
    "个人发票": "Personal invoice",
    "企业发票": "Enterprise invoice",
    "运费": "freight",
    "免运费": "Free shipping",
    "留言": "Leaving a message.",
    "建议留言前先与商家沟通确认": "It is recommended to communicate with the merchant before leaving a message",
    "合计": "total",
    "总计": "total",
    "提交订单": "place order",
    "运费说明": "Freight description",
    "无": "None",
    "确定": "determine",
    "选择优惠券": "Select Coupon",
    "暂无可用优惠券": "No coupons available",
    "开票": "Invoicing",
    "是否选择积分抵扣": "Whether to select point deduction",
    "请选择可用收货地址": "Please select an available shipping address",
    "订单提交成功，请支付…": "Order submitted successfully, please pay",
    "排行榜": "Ranking List",
    "好评率": "Favorable rate",
    "问答": "Q&A",
    "个回答": "Answers",
    "至少购买一件": "Purchase at least one piece",
    "批发": "wholesale",
    "成交": "deal",
    "单": "single",
    "上拉加载更多数据": "Pull up to load more data",
    "当前佣金": "Current commission",
    "收益统计": "Revenue statistics",
    "未结算": "Unsettled",
    "规则说明": "Rule description",
    "我的分销": "My distribution",
    "账户佣金": "Account commission",
    "冻结金额": "Frozen amount",
    "账户余额": "Account balance",
    "昨日收益": "Yesterday's earnings",
    "累计收益": "Accumulated income",
    "累计提现": "Accumulated withdrawal",
    "我的会员": "My Members",
    "订单统计": "Order statistics",
    "分销规则": "Distribution rules",
    "立即提现": "Immediate withdrawal",
    "推广人总数": "Total number of promoters",
    "直推人数": "Number of direct push",
    "间推人数": "Number of people pushing",
    "搜索关键字": "Search keywords",
    "姓名": "full name",
    "人员类别": "Personnel category",
    "加入时间": "Join time",
    "推广订单": "Promotion order",
    "累计推广订单": "Cumulative promotion orders",
    "订单号": "order number",
    "订单消费金额": "Order consumption amount",
    "下单人": "Order",
    "我的问答": "My Q&A",
    "搜索已有提问": "Search for existing questions",
    "人进行了回答": "People answered",
    "问问买家": "Ask the buyer",
    "我来回": "I go back and forth",
    "发布": "release",
    "我知道，我来答": "I know, I'll answer",
    "回复成功": "Reply succeeded",
    "等待后台审核，审核通过后可以去我的问答里查看已经回复的问答": "Wait for the background review. After the review, you can go to my Q&A to view the replies",
    "我知道了": "I got it!",
    "匿名回答": "Anonymous answer",
    "实名回答": "Real-name answer",
    "删除": "delete",
    "人回答": "People answer",
    "提问": "put questions to",
    "回答": "answer",
    "关注": "follow",
    "点赞": "Like",
    "确定删除提问吗？": "Are you sure to delete the question?",
    "确定删除该问题的所有回答吗？": "Are you sure to delete all answers to this question?",
    "问题详情": "Problem details",
    "条用户回答": "User responses",
    "已赞": "Like",
    "赞": "fabulous",
    "发布问题": "Issue Issues",
    "说出你的问题，已购买的人会帮你解答哦~": "Say your question, the person who has already purchased will help you answer it~",
    "发布成功": "Publishing succeeded",
    "等待后台审核，审核通过后可以去我的问答里查看已经发布的问答": "Wait for the background review. After the review, you can go to my Q&A to view the published Q&A",
    "请输入问题": "Please enter a question",
    "已领取过该优惠券~": "You have received the coupon~",
    "价格：": "Price",
    "筛选": "screen",
    "品牌": "brand",
    "最低价": "minimum price",
    "最高价": "Maximum price",
    "重置密码": "reset password",
    "综合推荐": "Comprehensive recommendation",
    "新增地址": "Add address",
    "加入购物": "Join shopping",
    "使用权限": "Use permissions",
    "全部评价": "All comments",
    "有文字": "With text",
    "有图": "Have a picture",
    "有视频": "With video",
    "领取": "receive",
    "立即购买": "Buy Now",
    "搜点什么": "Search something",
    "请输入要搜索的内容": "Please enter the content to search",
    "跳过": "Skip",
    "请输入支付密码": "Please enter the payment password",
    "开通指纹支付": "Enable fingerprint payment",
    "指纹支付": "Fingerprint payment",
    "金额": "amount of money",
    "验证支付密码，完成身份验证": "Verify payment password and complete identity verification",
    "支付方式": "Payment method",
    "余额": "balance",
    "支付密码为6位数字，用于提现、设置密保、添加银行卡等操作，可保障资金安全": "The payment password is a 6-digit number, which is used to withdraw cash, set security, add bank cards and other operations to ensure the security of funds",
    "忘记支付密码": "Forgot payment password",
    "完成": "Complete",
    "输入支付密码": "Enter payment password",
    "请设置新密码,用于支付验证": "Please set a new password for payment verification",
    "请再次输入,以确认密码": "Please enter again to confirm the password",
    "修改支付密码": "Modify payment password",
    "设置支付密码": "Set payment password",
    "请输入支付密码以验证身份": "Please enter the payment password to verify your identity",
    "请设置新的支付密码": "Please set a new payment password",
    "请再次输入支付密码以确认": "Please re-enter the payment password to confirm",
    "重置支付密码": "Reset payment password",
    "您是否要放弃设置支付密码": "Do you want to give up setting payment password",
    "您是否要放弃重置支付密码": "Do you want to give up resetting the payment password",
    "您是否要放弃修改支付密码": "Do you want to give up changing the payment password",
    "关闭提示": "Close prompt",
    "我再想想": "I'll think about it again",
    "请输入": "Please enter",
    "请输入:": "Please enter:",
    "位支付密码": "Bit payment password",
    "两次支付密码输入不一致": "The two payment passwords are inconsistent",
    "正在设置密码": "Setting password",
    "正在重置密码": "Resetting password",
    "我怎样注册app？": "How do I register an app?",
    "怎样修改密码？": "How to change the password?",
    "积分规则是什么？": "What is the integral rule?",
    "怎样获得优惠券？": "How do I get coupons?",
    "怎样查找\/领取优惠券？": "How to find\/get coupons?",
    "即刻体验": "Instant experience",
    "历史搜索": "Historical search",
    "全部删除": "Delete all",
    "搜索发现": "Search Discovery",
    "换一批": "Change batch",
    "推荐商品": "Pick of the week",
    "点击说出你想要的商品": "Click to say what you want",
    "热销榜": "Hot List",
    "热搜榜": "Hot search list",
    "确定删除历史记录？": "Are you sure to delete history?",
    "未检测到语音": "No voice detected",
    "当前版本": "current version",
    "中犇科技版权所有": "All rights reserved by Zhongben Technology",
    "人脸识别": "Face recognition",
    "开启成功": "Open successfully",
    "关闭成功": "Close successfully",
    "已阅读并同意": "Read and agree",
    "此设备未录入指纹，请到设置中开启": "No fingerprint is entered for this device. Please turn it on in the settings",
    "你确定要关闭指纹支付吗？": "Are you sure you want to turn off fingerprint payment?",
    "新手机号码": "New mobile number",
    "请输入新的手机号": "Please enter a new mobile number",
    "短信验证": "SMS verification",
    "获取短信验证码": "Get SMS verification code",
    "重新获取": "Reacquire",
    "请输入新手机号": "Please enter a new phone number",
    "旧密码": "Old password",
    "请输入当前密码": "Please enter the current password",
    "新密码": "New password",
    "请输入新密码": "Please enter a new password",
    "确认密码": "Confirm Password",
    "请再次输入新密码": "Please enter the new password again",
    "请输入旧密码": "Please enter the old password",
    "请输入字母加数字6-12位旧密码": "Please enter a 6-12 digit old password with letters and numbers",
    "请输入字母加数字6-12位新密码": "Please enter a new password of 6-12 letters and numbers",
    "新密码与旧密码一致，请重新输入": "The new password is consistent with the old password, please re-enter",
    "请输入确认新密码": "Please enter a new password to confirm",
    "新密码不一致，请重新输入": "The new password is inconsistent, please re-enter",
    "反馈类型": "Feedback type",
    "反馈内容不能为空": "Feedback content cannot be empty",
    "问题描述的越详细.有助于我们更快的解决问题": "The more detailed the problem description is, it will help us solve the problem faster",
    "必填": "Required",
    "银行卡号": "Bank card number",
    "请输入您的手机号码": "Please enter your mobile number",
    "请输入您的QQ号码": "Please enter your QQ number",
    "请输入您的邮箱": "Please enter your email",
    "友情提示": "Friendly tips",
    "确定要删除图片吗？": "Are you sure you want to delete the picture?",
    "请填写你的手机号码": "Please fill in your mobile number",
    "请检查您的手机号码格式": "Please check your mobile number format",
    "请填写你的QQ": "Please fill in your QQ",
    "请检查您的QQ号码格式": "Please check your QQ number format",
    "请填写你的邮箱": "Please fill in your email",
    "请检查您的邮箱格式": "Please check your email format",
    "下载": "download",
    "旧密码验证修改": "Old password verification modification",
    "我们要对您绑定的手机号进行验证": "We need to verify your bound mobile phone number",
    "下一步": "next step",
    "修改密码": "Change Password",
    "修改绑定手机号": "Modify bound phone number",
    "验证码错误": "Verification code error",
    "旧支付密码验证修改": "Verification and modification of old payment password",
    "联系方式": "contact information",
    "反馈时间": "Feedback time",
    "平台回复": "Platform reply",
    "暂无反馈内容": "No feedback content",
    "更换手机号": "Change mobile phone number",
    "设置手势密码": "Set gesture password",
    "忘记手势密码": "Forgot gesture password",
    "生物支付": "Biological payment",
    "指纹": "fingerprint",
    "支付": "payment",
    "语言": "language",
    "系统版本": "System version",
    "清除缓存": "Clear cache",
    "退出登录": "Log out",
    "您已设置手势密码": "You have set the gesture password",
    "确定退出当前账号？": "Are you sure to exit the current account?",
    "积分抵扣": "Point deduction",
    "账户积分数": "Account score",
    "本单": "This order",
    "已减": "Subtracted",
    "积分可减": "Points can be subtracted",
    "抵扣": "Deduction",
    "使用密码": "Use password",
    "你暂未开启指纹支付": "You haven't opened fingerprint payment yet",
    "去开启": "Go open it",
    "请验证指纹": "Please verify the fingerprint",
    "支付中...": "Paying",
    "识别失败": "Identification failed",
    "此设备不支持指纹识别功能": "This device does not support fingerprint recognition",
    "此平台不支持指纹识别": "Fingerprint recognition is not supported on this platform",
    "立即兑换": "Redeem now",
    "积分不足": "Insufficient points",
    "积分兑换中，请稍等…": "Points are being exchanged, please wait",
    "支付剩余时间": "Remaining time of payment",
    "可用余额": "Available balance",
    "确认支付": "Confirm payment",
    "支付密码错误，请重试": "Payment password error, please try again",
    "重试": "retry",
    "确认要离开收银台?": "Are you sure you want to leave the cashier?",
    "您的订单将会被取消!": "Your order will be cancelled!",
    "继续支付": "Continue to pay",
    "确认离开": "Confirm to leave",
    "该订单下包含有已下架商品，请重新下单": "This order contains goods that have been removed from the shelf. Please re-order",
    "支付失败,原因为": "Payment failed because",
    "订单无效，支付失败!": "Invalid order, payment failed!",
    "小时": "hour",
    "分钟": "minute",
    "秒杀": "seckill",
    "兑换结果": "Exchange results",
    "兑换成功": "Redemption succeeded",
    "返回积分商城": "Return to the Points Mall",
    "添加地址信息": "Add address information",
    "该商品已兑换完了,看看其它的吧": "This item has been redeemed. Let's have a look at others",
    "兑换数量超过商品上限": "The exchange quantity exceeds the product limit",
    "请先添加收货地址": "Please add the shipping address first",
    "积分商城": "Points Mall",
    "兑换记录": "Exchange record",
    "可用积分": "Available Points",
    "当前积分": "Current points",
    "剩余": "surplus",
    "已兑": "Cashed",
    "兑换": "exchange",
    "购买": "buy",
    "你可能还喜欢": "You may also like it",
    "订单详情": "Order details",
    "售后处理中": "After sales processing",
    "用户取消": "User cancel",
    "商家驳回": "Merchant rejection",
    "同意退款": "Agree to refund",
    "确认收回": "Confirm withdrawal",
    "退款成功": "Refund succeeded",
    "申请售后": "Apply for after-sales service",
    "查看售后详情": "View after-sales details",
    "联系客服": "Contact customer service",
    "需付款": "Payment required",
    "总额": "total",
    "订单备注": "Order remarks",
    "下单时间": "Order time",
    "支付金额": "Payment amount",
    "支付时间": "Payment time",
    "删除订单": "Delete order",
    "取消订单": "Cancel order",
    "提醒发货": "Remind shipment",
    "已提醒": "Reminded",
    "查看物流": "View logistics",
    "确认收货": "Confirm receipt",
    "等待买家付款中": "Waiting for buyer to pay",
    "订单已付款，等待卖家发货": "The order has been paid, waiting for the seller to ship",
    "卖家已发货": "Seller has shipped",
    "交易成功": "Successful trade",
    "订单已评价": "Order evaluated",
    "余额支付": "Balance payment",
    "微信支付": "WeChat payment",
    "支付宝支付": "Alipay payment",
    "小程序支付": "Applet payment",
    "确定要取消订单吗?": "Are you sure you want to cancel the order?",
    "确认删除此订单?": "Are you sure to delete this order?",
    "删除后不可恢复": "Not recoverable after deletion",
    "删除成功": "Delete succeeded",
    "已提醒,请耐心等待": "Reminded, please wait patiently",
    "售后取消": "After-sales cancellation",
    "申请驳回": "Application rejected",
    "商家确认收货": "Merchant confirms receipt",
    "同意申请": "Agree to apply",
    "去评价": "To evaluate",
    "待发货": "To be shipped",
    "待收货": "Goods to be received",
    "您是否确认收到货物?": "Are you sure you have received the goods?",
    "积分规则": "Integral rule",
    "我的积分": "My Points",
    "积分明细": "Points details",
    "犇腾家": "Ben Teng's family",
    "人性化电商领跑者": "Humanized e-commerce leader",
    "搜索你想要的商品": "Search for the product you want",
    "暂无相关数据": "No relevant data",
    "标签": "label",
    "编辑": "edit",
    "收货人": "consignee",
    "联系电话": "contact number",
    "所在地区": "Region",
    "请选择省市区县、乡镇": "Please select a province, city, county or town",
    "请输入详细地址": "Please enter the detailed address",
    "设置默认地址": "Set default address",
    "请填写标签名称（最多5个字）": "Please fill in the label name (up to 5 characters)",
    "保存": "preservation",
    "打开权限失败": "Failed to open permissions",
    "编辑收货地址": "Edit shipping address",
    "标签已存在": "Label already exists",
    "请输入内容": "Please enter content",
    "请输入收货人姓名": "Please enter the name of the consignee",
    "手机号格式不正确": "Mobile phone number format is incorrect",
    "地区不能为空": "Region cannot be empty",
    "详细地址不能为空": "Detailed address cannot be empty",
    "详细地址不能含有特殊字符": "Detailed address cannot contain special characters",
    "详细地址不能含有表情": "Detailed address cannot contain emoticons",
    "是否删除该地址": "Delete this address",
    "女士": "ma'am",
    "先生": "sir",
    "默认地址,": "Default address,",
    "设为默认": "Set as default",
    "您未添加任何地址": "You haven't added any addresses",
    "导入微信地址": "Import WeChat address",
    "新增收货地址": "Add delivery address",
    "确定删除该地址": "Confirm to delete the address",
    "导入成功": "Import succeeded",
    "可用": "Available",
    "全场可用": "All available",
    "有效期至：": "Valid until:",
    "去使用": "To use",
    "已使用": "Used",
    "已过期": "Expired",
    "未使用": "not used",
    "已失效": "Expired",
    "邀请好友": "Invite friends",
    "复制邀请码": "Copy invitation code",
    "分享海报": "Share posters",
    "快来下载app,体验更多快乐": "Come and download the app and experience more happiness",
    "你的好友": "Your friends",
    "邀请你": "Invite you",
    "发票详情": "Invoice details",
    "申请中": "In application",
    "已开票": "Invoiced",
    "已开票金额：￥": "Invoiced amount=>￥",
    "商品明细": "Item details",
    "个人": "personal",
    "抬头名称": "Header name",
    "开票金额": "Invoiced amount",
    "物流公司": "logistics company",
    "物流单号": "Logistics bill No",
    "复制": "copy",
    "开票时间": "Invoicing time",
    "暂无": "None",
    "申请时间": "Application time",
    "修改申请": "Modify application",
    "订单提交": "Order submission",
    "订单完成": "Order completion",
    "开票完成": "Invoicing completed",
    "请在手机端操作": "Please operate on the mobile terminal",
    "订单编号：": "Order No.:",
    "电子普通发票": "Electronic ordinary invoice",
    "查看详情": "View details",
    "已开": "Opened",
    "修改发票": "Modify invoice",
    "修改成功": "Modified successfully",
    "申请成功": "Successful application",
    "登录": "Sign in",
    "跳过，看好物": "Skip and watch",
    "申请获取以下权限": "Apply for the following permissions",
    "获得你的公开信息(昵称，头像、地区等)": "Get your public information (nickname, avatar, region, etc.)",
    "微信手机号一键登录": "One-click login via WeChat mobile number",
    "注册登录即同意": "Sign in and agree",
    "《犇腾家平台服务协议》": "Bentengjia Platform Service Agreement",
    "和": "and",
    "《隐私政策》": "《Privacy Policy》",
    "登录中...": "Signing in",
    "用于完善会员资料": "Used to improve member information",
    "授权失败，请使用其他方式登录": "Authorization failed. Please log in using other methods",
    "获取用户授权失败": "Failed to obtain user authorization",
    "授权登录": "Authorized login",
    "获得你的手机号码信息": "Get your mobile number information",
    "绑定手机号": "Bind mobile phone number",
    "绑定中...": "Binding",
    "获取授权失败": "Failed to obtain authorization",
    "手机号": "cell-phone number",
    "验证码": "Verification Code",
    "请输入验证码": "Please enter the verification code",
    "s后重新获取": "Reacquire after s",
    "获取验证码": "Get code",
    "密码": "password",
    "请输入字母加数字(6-12位)": "Please enter letters and numbers (6-12 digits)",
    "邀请码（选填": "Invitation code (optional",
    "请输入邀请码": "Please enter the invitation code",
    "立即登录": "Sign in now",
    "请输入手机号码": "Please enter your mobile number",
    "请填写正确手机号码": "Please fill in the correct mobile number",
    "验证码为": "The verification code is",
    "请注意查收": "Please remember to check",
    "请输入字母加数字6-12位密码": "Please enter a 6-12 digit password with letters and numbers",
    "忘记密码": "Forgot password",
    "账号": "account number",
    "请输入正确的手机号": "Please enter the correct mobile number",
    "密码登录": "Password login",
    "快捷登录": "Quick login",
    "未注册的手机号验证后将自动创建": "Unregistered mobile phone numbers will be automatically created after verification",
    "登录即代表您已同意": "Login means you have agreed",
    "隐私协议": "Privacy Agreement",
    "请阅读并勾选页面协议": "Please read and check the page agreement",
    "请安装微信后再使用此功能": "Please install WeChat before using this feature",
    "注册账号": "Registered account",
    "验证码登录": "Authentication code login",
    "注册": "register",
    "用户协议": " User Agreement ",
    "《用户协议》": " User Agreement ",
    "请输入邀请码(选填)": " Please enter the invitation code (optional) ",
    "签到记录": "Sign-in record",
    "签到奖励": "Sign in reward",
    "签到": "Sign in",
    "连续签到七天积分翻倍": "Points doubled for seven consecutive days",
    "天": "day",
    "立即签到": "Sign in immediately",
    "已签到": "Signed in",
    "签到成功": "Sign in successfully",
    "获得": "get",
    "积分": "integral",
    "好的": "good",
    "今日已签到,请勿重复签到": "You have signed in today. Please do not sign in again",
    "真实姓名": "Real name",
    "中国大陆": "Chinese Mainland",
    "手机号码": "phone number",
    "身份证号": "ID number",
    "请输入身份证号": "Please enter ID number number",
    "身份证正面（国徽面）": "Front of ID card (national emblem)",
    "身份证反面（头像面）": "The reverse side of the ID card (face of the head)",
    "提交申请成功": "Application submitted successfully",
    "请输入正确的手机号码": "Please enter the correct mobile number",
    "请输入正确的身份证号": "Please enter the correct ID number number",
    "请输入姓名": "Please enter your name",
    "请上传身份证正面": "Please upload the front of your ID card",
    "请上传身份证反面": "Please upload the reverse side of your ID card",
    "选择图片": "Select Picture",
    "重新选择": "Reselect",
    "个人资料": "personal data",
    "头像": "head portrait",
    "昵称": "nickname",
    "请输入昵称": "Please enter your nickname",
    "性别": "Gender",
    "生日": "birthday",
    "邮箱": "mailbox",
    "请绑定邮箱": "Please bind the mailbox",
    "所在地": "Location",
    "点击选择": "Click to select",
    "保密": "secrecy",
    "男": "Male",
    "女": "Female",
    "请选择生日": "Please select a birthday",
    "你有修改未保存，是否确认保存?": "You have unsaved changes. Are you sure to save?",
    "请输入正确的邮箱账号": "Please enter the correct email account",
    "选中了第": "The item",
    "个按钮": "Buttons",
    "请选择正确的时间": "Please select the correct time",
    "修改头像": "Modify avatar",
    "拍照": "photograph",
    "从手机相册选择": "Select from mobile photo album",
    "选择": "choice",
    "请输入您的用户昵称": "Please enter your user nickname",
    "请检查您的昵称(最多10个字符)": "Please check your nickname (up to 10 characters)",
    "请选择您的生日": "Please select your birthday",
    "我的收藏": "My collection",
    "管理": "Administration",
    "全选": "Select All",
    "取消全选": "Deselect All",
    "请选择要删除的商品": "Please select the item to delete",
    "我的足迹": "My footprint",
    "支付宝": "Alipay",
    "已绑定": "Bound",
    "微信": "WeChat",
    "第一步：先获取手机验证码": "Step 1=> Get the mobile phone verification code first",
    "绑定的用户手机": "Bind user's mobile phone",
    "第二步：上传支付宝收款二维码": "Step 2=> Upload Alipay collection QR code",
    "上传二维码": "Upload QR code",
    "第三步：填写支付宝真实姓名": "Step 3=> Fill in the real name of Alipay",
    "请输入真实姓名": "Please enter your real name",
    "重新获取(60)": "Reacquire (60)",
    "重新获取(": "Reacquire（",
    "请先获取验证码": "Please get the verification code first",
    "收款码未上传": "Collection code not uploaded",
    "姓名输入有误": "Incorrect name input",
    "真实姓名输入有误": "Incorrect input of real name",
    "余额明细": "Balance details",
    "待审核 ,": "To be reviewed,",
    "审核通过": "Approved",
    "审核驳回": "Approval rejection",
    "转账拒绝": "Transfer Rejection",
    "收支记录": "Revenue and expenditure records",
    "支出记录": "Expense record",
    "我的钱包": "My wallet",
    "绑定账户": "Bind account",
    "可提现余额(元)": "Withdrawable balance (yuan)",
    "近30条记录": "Nearly 30 records",
    "提现": "Cash withdrawal",
    "输入提现金额": "Enter withdrawal amount",
    "请输入提现金额": "Please enter the withdrawal amount",
    "提现收取5%的手续费": "5% service charge for withdrawal",
    "提现收取1%的手续费": "1% service charge for withdrawal",
    "选择提现方": "Select withdrawal party",
    "提现规则": "Cash withdrawal rules",
    "请先绑定支付宝": "Please bind Alipay first",
    "请先绑定微信": "Please bind WeChat first",
    "没有可提现的金额": "No amount to be withdrawn",
    "当前余额低于最低提现金额限制": "The current balance is lower than the minimum withdrawal amount limit",
    "最小提现金额为": "The minimum withdrawal amount is",
    "可提现余额不足": "Insufficient withdrawable balance",
    "提现明细": "Cash withdrawal details",
    "余额提现": "Balance withdrawal",
    "拒绝原因：": "Reason for rejection:",
    "提交申请成功,等待管理员审核": "The application is submitted successfully, waiting for the administrator's review",
    "(审核周期1-2个工作日)": "(Audit cycle 1-2 working days)",
    "提现方式：": "Cash withdrawal method:",
    "提现金额：": "Cash withdrawal amount:",
    "继续提现": "Continue to withdraw",
    "税号不能含有汉字": "The tax number cannot contain Chinese characters",
    "银行卡号有误": "Wrong bank card number",
    "手机号有误": "Wrong mobile number",
    "分享方式": "Sharing method",
    "获取图片信息失败": "Failed to get picture information",
    "使用权限=>满": "Permission=> full",
    "元使用": "Meta use",
    "有效期至=>": "Valid until:",
    "清理下架商品": "Clean the goods off the shelf",
    "购物车竟然是空的": "The shopping cart is empty",
    "再忙，也要记得买点什么犒赏自己~": "No matter how busy you are, remember to buy something to reward yourself~",
    "去登录": "Go to login",
    "随便逛逛": "Look around",
    "已售罄": "Sold out",
    "提交审核": "Submit for review",
    "已下架": "Off shelf",
    "选规格": "Select specification",
    "去结算": "To settle",
    "移入收藏": "Move into collection",
    "确认删除吗?": "Are you sure to delete?",
    "该商品已售完,正在采购中": "The product has been sold out and is under purchase",
    "该商品已下架": "This item has been removed from the shelf",
    "未选择商品": "No item selected",
    "请选择要移动商品": "Please select an item to move",
    "确认移入收藏夹吗?": "Are you sure to move into favorites?",
    "请选择商品": "Please select an item",
    "请选择要移除下架商品": "Please select the item to be removed from the shelf",
    "所选商品包含正常销售商品,请检查": "The selected product contains normal sales products, please check",
    "确认移除所选商品吗?": "Are you sure to remove the selected item?",
    "获取商品规格失败": "Failed to get product specification",
    "推荐分类": "Recommended classification",
    "邀请码": "Invitation code",
    "请先登录": "Login",
    "登录后查看更多": "View more after login",
    "我的优惠券": "My coupon",
    "退换\/售后": "Return\/After Sales",
    "我的消息": "My message",
    "我的发票": "My invoice",
    "地址管理": "Address Management",
    "分销中心": "Distribution Center",
    "您的申请正在审核中": "Your application is under review",
    "您已认证通过": "You have been certified",
    "领取优惠券": "Receive coupons",
    "请": "Please",
    "前领取": "Previous claim",
    "领取成功": "Received successfully",
    "欢迎加入,请登录\/注册享超值优惠!": "Welcome to join, please log in\/register to enjoy the premium discount!",
    "确认选择": "Confirm selection",
    "消息通知": "Message notification",
    "确定删除此消息？": "Are you sure to delete this message?",
    "跳转首页": "Jump to home page",
    "暂无标题": "No title temporarily",
    "无具体内容": "No specific content",
    "系统通知": "System notification",
    "暂无新消息": "No new message",
    "物流信息": "Logistics information",
    "订单信息": "Order information",
    "其他消息": "Other messages",
    "发送链接": "Send Link",
    "发送": "send out",
    "系统助手": "System Assistant",
    "您好，有问题请留言": "Hello, please leave a message if you have any questions",
    "按住说话": "Hold to talk",
    "手指上滑取消发送": "Slide your finger up to cancel sending",
    "正在转接中...": "Transferring",
    "松开结束": "End of release",
    "松开手指取消发送": "Release your finger to cancel sending",
    "图片上传失败，请稍后再试.": "Image upload failed. Please try again later",
    "售后选择": "After-sales selection",
    "原因": "reason",
    "退款说明": "Refund instructions",
    "请在此描述申请售后服务的原因": "Please describe the reason for applying for after-sales service here",
    "已收到货": "Goods received",
    "未收到货": "Goods not received",
    "不喜欢": "dislike",
    "质量问题": "Quality problems",
    "不合适": "inappropriate",
    "七天无理由退货": "Return without reason within seven days",
    "退款": "refund",
    "退货退款": "Return refund",
    "换货": "exchange goods",
    "请输入退款说明": "Please enter the refund description",
    "退款总额": "Total refund",
    "商品信息": "Product information",
    "实际支付": "Actual payment",
    "申请数量": "Number of applications",
    "服务单号": "Service order No",
    "服务类型": "Service type",
    "申请原因": "Reason for application",
    "退货地址": "Return address",
    "收件人": "addressee",
    "快递名称": "Express name",
    "快递单号": "courier number",
    "退款凭证照片": "Photo of refund voucher",
    "取消申请": "withdraw",
    "寄回商品": "Return goods",
    "提交申请": "Submit application",
    "商家审核": "Merchant review",
    "商家收货": "Merchant receiving",
    "服务已取消,如有需要可在售后申请页重新提交服务单": "The service has been cancelled. If necessary, you can resubmit the service order on the after-sales application page",
    "服务单已取消": "The service order has been canceled",
    "商家已驳回,如有疑问请联系商家客服": "The merchant has rejected it. If you have any questions, please contact the merchant customer service",
    "您的服务单已申请成功,待售后审核中": "Your service order has been applied successfully and is pending after-sales review",
    "商家已同意您的售后申请,将在(1-3)工作日内退款": "The merchant has approved your after-sales application and will refund it within (1-3) working days",
    "商家已同意您的售后申请,请尽快寄回商品": "The merchant has approved your after-sales application, please send the goods back as soon as possible",
    "商家已收货,将在(1-3)工作日处理": "The merchant has received the goods, which will be processed within (1-3) working days",
    "服务已完成,感谢您对本平台的支持": "The service has been completed. Thank you for your support of this platform",
    "商家已发货,感谢您对本平台的支持": "The merchant has delivered the goods. Thank you for your support of this platform",
    "选择物流公司": "Select logistics company",
    "运单单号": "Waybill No",
    "请输入有效的快递单号": "Please enter a valid express bill number",
    "无效的售后单": "Invalid after-sales order",
    "请选择物流公司": "Please select a logistics company",
    "无效的物流单号": "Invalid logistics order number",
    "物流信息已提交售后,等待商家审核": "The logistics information has been submitted to the after-sales service, waiting for the review of the merchant",
    "已处理": "Processed",
    "商家已同意": "Merchant has agreed",
    "商家已收回": "Merchant has withdrawn",
    "商家已打款": "Merchant has paid",
    "确定取消申请吗？": "Are you sure to cancel the application?",
    "上传失败,请检查网络设置": "Upload failed. Please check the network settings",
    "后置摄像头": "Rear camera",
    "前置摄像头": "front camera",
    "符合评价规则,评价超过10个字即可获得积分": "In line with the evaluation rules, scores can be obtained if the evaluation exceeds 10 words",
    "添加图片": "Add picture",
    "添加视频": "Add Video",
    "匿名评价": "Anonymous evaluation",
    "非常好": "very nice",
    "非常差": "Very poor",
    "差": "difference",
    "一般": "commonly",
    "好": "Okay",
    "您的手速太快了": "Your hand speed is too fast",
    "请输入您对该商品评论内容": "Please enter your comments on this product",
    "评论成功": "Comment succeeded",
    "评论": "comment",
    "未成团": "Ungrouped",
    "尾款未支付": "Unpaid balance",
    "预售": "open to booking",
    "拼团": "Collage",
    "积分抵扣了": "Points deducted",
    "支付尾款": "Pay the balance",
    "去支付": "To pay",
    "申请发票": "Apply for invoice",
    "查看发票": "View invoice",
    "请选择取消订单原因": "Please select the reason for canceling the order",
    "请选择取消原因": "Please select the cancellation reason",
    "操作中": "In operation",
    "暂无物流公司信息": "No logistics company information",
    "暂无物流单号信息": "No logistics order number information",
    "暂无物流信息": "No logistics information",
    "优惠券": "coupon",
    "需付定金": "Deposit required",
    "应付尾款": "Balance payable",
    "实付款": "Actual payment",
    "付款金额": "Payment amount",
    "拼团明细": "Group details",
    "开团时间": "Opening time",
    "是否成团": "Group",
    "是": "Yes",
    "否": "No",
    "预售明细": "Pre-sale details",
    "尾款开始时间": "Start time of balance payment",
    "尾款结束时间": "End time of balance payment",
    "去付款": "To pay",
    "订单已取消": "Order canceled",
    "订单待付款": "Order to be paid",
    "订单待发货": "Order to be shipped",
    "订单待收货": "Order to be received",
    "订单已完成": "Order completed",
    "苹果内购": "Apple internal purchase",
    "电子发票": "Electronic invoice",
    "发票信息": "Invoice information",
    "发票抬头不能为空": "Invoice header cannot be blank",
    "企业单位税号不能为空": "Enterprise tax number cannot be empty",
    "电子邮箱": "E-mail",
    "电子邮箱不能为空": "Email cannot be empty",
    "请检查手机号": "Please check your mobile number",
    "请输入联系方式": "Please enter contact information",
    "请检查邮箱": "Please check your mailbox",
    "阶段1": "Phase 1",
    "阶段2": "Phase 2",
    "同意支付定金": "Agree to pay the deposit",
    "预售商品,定金不退哦": "Pre-sale goods, deposit not refundable",
    "积分使用规则": "Rules for use of points",
    "使用限制：无限制": "Use restriction=> unlimited",
    "预售商品定金不支持退款,同意后可继续下单.": "The deposit of pre-sale goods does not support refunds. You can continue to place orders after you agree",
    "组合支付(余额可抵扣": "Combined payment (balance can be deducted",
    "时": "Hour",
    "分": "branch",
    "您的订单将会被取消": "Your order will be cancelled",
    "您的订单在": "Your order is on",
    "内未支付将被取消,请尽快完成支付": "Unpaid payment will be cancelled. Please complete the payment as soon as possible",
    "订单无效，支付失败": "Invalid order, payment failed",
    "支付失败,原因为:": "Payment failed because:",
    "混合支付-微信支付失败": "Hybrid payment - WeChat payment failed",
    "恭喜你": "congratulations",
    "您获得了": "You have",
    "元优惠券": "RMB coupon",
    "查看订单": "View order",
    "再去逛逛": "Go shopping again",
    "恭喜你，抽中了奖项": "Congratulations, you won the prize",
    "谢谢参与": "Thank you for participating",
    "很遗憾!,什么都没抽到": "unfortunately!, Nothing",
    "谢谢您的参与": "Thank you for your participation",
    "请领取": "Please get",
    "领取失败，请重新操作": "Failed to claim. Please operate again",
    "你已经成功领取，请勿重复领取": "You have successfully claimed, please do not claim again",
    "后台下单": "Place orders in the background",
    "系统设置": "System settings",
    "广告页": "Advertising page",
    "付款成功": "Payment succeeded",
    "关于我们": "About us",
    "历史反馈": "Historical feedback",
    "反馈与帮助": "Feedback and help",
    "售后列表": "After-sales list",
    "售后详情": "After-sales details",
    "填写寄回信息": "Fill in the return information",
    "实名认证": "Real-name authentication",
    "提交反馈": "Submit feedback",
    "提现申请成功": "Cash withdrawal application succeeded",
    "收银台": "Cashier",
    "消息": "news",
    "消息详情": "Message details",
    "添加收货地址": "Add shipping address",
    "生物检测": "Biological detection",
    "申请开票": "Apply for invoicing",
    "确认订单": "Confirm order",
    "签到规则": "Sign-in rules",
    "系统消息": "System messages",
    "绑定微信": "Bind WeChat",
    "绑定支付宝": "Bind Alipay",
    "绑定新手机": "Bind new phone",
    "账号绑定": "Account binding",
    "验证码验证手机号": "Verification code verification mobile number",
    "第": "No",
    "请授权获取当前位置": "Please authorize to obtain the current location",
    "您还没有选泽自取人,去选择": "You haven't chosen your own person yet",
    "您还没有选中自取点,去选择": "You have not selected the self-fetching point. Go to select it",
    "选择自取时间": "Select self-pickup time",
    "请选择": "Please select",
    "选择时间": "Select time",
    "请选择提货人": "Please select the consignee",
    "请选择自取点": "Please select a self-fetching point",
    "请选择自取日期": "Please select the date of self-collection",
    "请选择自取时间段": "Please select your own time period",
    "自取时间": "Self-collection time",
    "待提货": "To be picked up",
    "提货成功": "Pickup succeeded",
    "组合支付": "Combined payment",
    "选择自取点": "Select self-fetching point",
    "重新定位": "Repositioning",
    "商品自取点": "Commodity self-collection point",
    "输入地址，查找附近自提点": "Enter the address to find the nearby self-feed point",
    "提货人": "Picker",
    "设置默认提货人": "Set Default Picker",
    "编辑提货人": "Edit Picker",
    "添加提货人": "Add Picker",
    "选择位置": "Select location",
    "当前选择": "Current selection",
    "该地区还没有自取点": "There is no self-collection point in this area",
    "提货人列表": "Picker list",
    "用户反馈": "User feedback",
    "我的反馈": "My feedback",
    "绑定银行卡": "Bind bank card",
    "您未设置支付密码，请设置支付密码？": "You have not set a payment password, please set a payment password?",
    "点击登录即默认同意": "Click Login to agree by default",
    "《用户注册协议》": "《 the User Registration Agreement》",
    "验证码不能为空": "Verification code cannot be empty",
    "绑定手机号并登录": "Bind mobile number and log in",
    "微信登录": "WeChat login",
    "手机号登陆": "Login with mobile number",
    "与": "and",
    "登录\/注册": "Login\/Registration",
    "待评价": "To be evaluated",
    "犇腾家平台服务协议及隐私政策 :": "Bentengjia Platform Service Agreement and Privacy Policy:",
    "不同意": "disagree",
    "同意": "agree",
    "去签到": "Sign in",
    "请支付…": "Please pay",
    "该商品只剩": "This item is only left",
    "你可以去我的问答里查看你已经回复的问答": "You can check the answers you have answered in my Q&A",
    "你可以去我的问答里查看你已经发布的问答": "You can check your published Q&A in my Q&A",
    "刚刚兑换了": "Just exchanged",
    "积分兑换": "Points redemption",
    "小积分抽大奖": "Small points draw big prize",
    "已删除": "Deleted",
    "会员权益": "Membership interests",
    "普通会员": "Ordinary members",
    "银卡会员": "Silver card member",
    "金卡会员": "Gold member",
    "钻卡会员": "Drill card member",
    "我的VIP": "My VIP",
    "会员规则": "Membership rules",
    "会员等级": "Membership level",
    "自购买之日起，12个月内有效": "Valid for 12 months from the date of purchase",
    "特权说明": "Privilege description",
    "立即续费": "Renew immediately",
    "已连续签到": "Continuous check-in",
    "查看积分规则": "View point rules",
    "充值": "Recharge",
    "充值金额": "Recharge amount",
    "售价": "price",
    "自定输入金额": "Self-defined input amount",
    "请输入充值金额": "Please enter the recharge amount",
    "选择支付方式": "Select payment method",
    "立即充值": "Recharge now",
    "请稍等，正在发起支付": "Please wait, payment is being initiated",
    "支付成功": "Payment succeeded",
    "网络繁忙,请稍后重试": "The network is busy, please try again later",
    "智能填写": "Intelligent filling",
    "请复制地址黏贴至此自动识别填写地址": "Please copy the address and paste it here to automatically identify and fill in the address",
    "填写": "fill in",
    "填写成功，请仔细检查如有错误请手动修改": "Fill in successfully. Please check carefully. If there is any error, please modify it manually",
    "请选择标签一个标签": "Please select a label",
    "用户注册协议": "User Registration Agreement",
    "隐私政策": " Privacy Policy ",
    "手机号快捷登录": "Mobile number quick login",
    "第三方登录": "Third-party login",
    "请输入密码": "Please input a password",
    "个人中心": "Personal Center",
    "一句话介绍自己": "Introduce yourself in one sentence",
    "每日签到": "Daily check-in",
    "取消\/售后": "Cancellation\/after-sales",
    "帮助中心": "Help Center",
    "点击编辑个性签名(10字以内": "Click to edit personal signature (within 10 words",
    "请输入6-12位密码": "Please enter a 6-12 digit password",
    "请勾选用户协议": "Please check the user agreement",
    "没有收到验证码": "No verification code received",
    "后重新发送新验证码": "Then resend the new verification code",
    "未注册手机号验证后自动创建平台账号": "Automatically create platform account after verification of unregistered mobile phone number",
    "未到账金额": "Amount not received",
    "状态": "state",
    "总金额(元)": "Total amount (yuan)",
    "冻结金额(元)": "Frozen amount (yuan)",
    "继续加油": "Keep going",
    "会员权益有效期至": "Membership benefits are valid until",
    "成长值即可升级": "Growth value can be upgraded",
    "未签": "Unsigned",
    "周一": "Monday",
    "周二": "Tuesday",
    "周三": "Wednesday",
    "周四": "Thursday",
    "周五": "Friday",
    "周六": "Saturday",
    "周日": "Sunday",
    "去完成": "To complete",
    "会员说明": "Member description",
    "九宫格": "Jiugongge",
    "账户积分": "Account points",
    "地址": "address",
    "订单总价": "Total order price",
    "会员积分(当前积分": "Member points (current points",
    "尾款支付时间": "Final payment time",
    "免邮": "Free of mail",
    "确认收货后才能申请售后": "Apply for after-sales service only after confirming receipt",
    "宝贝": "baby",
    "该商品暂无评论哦": "There is no comment on this product",
    "手机号登录": "Mobile number login",
    "请输入密码(6-12位字母数字)": "Please enter the password (6-12 alphanumeric characters)",
    "请输入密码(6~12位字母数字)": "Please enter the password (6~12 alphanumeric characters)",
    "请输入密码(6~12位字母+数字)": "Please enter the password (6~12 letters+numbers)",
    "已有账号，前去": "You have an account, go ahead",
    
    "请输入新密码(6-12位字母数字)": "Please enter a new password (6-12 alphanumeric characters)",
    "请输入新密码(6~12位字母数字)": "Please enter a new password (6~12 alphanumeric characters)",
    "请输入新密码（6-12位字母数字）": "Please enter a new password (6-12 alphanumeric characters)",
    "您的购物车还没有商品，快去挑选吧": "Your shopping cart doesn't have any products yet, go and pick them up quickly",
    "去挑选好货": "Go and select good goods",
    "包邮": "free shipping",
    "立即支付": "Immediate payment",
    "返回首页": "Return to the first page",
    "绑定账号": "Bind account",
    "请选择提现方式": "Please select the withdrawal method",
    "已选": "Selected",
    "意见反馈": "Feedback",
    "检查更新": "Check for updates",
    "获取短信验证": "Get SMS verification",
    "请再次输入新支付密码": "Please enter the new payment password again",
    "确认新密码": "Confirm new password",
    "添加地址": "Add Address",
    "添加": "add to",
    "确定删除该地址?": "Are you sure to delete this address?",
    "我要反馈": "I want feedback",
    "反馈记录": "Record",
    "请上传应用截图，最多上传": "Please upload screenshots of the application, and upload at most",
    "张": "Zhang",
    "请留下您的联系方式": "Please leave your contact information",
    "手机号\/邮箱\/QQ号": "Mobile number\/email\/QQ number",
    "请留下你的联系方式": "Please leave your contact information",
    "手机号验证修改": "Mobile number verification and modification",
    "请选择国际电话区号": "Please select international telephone area code",
    "常用区号": "Common area code",
    "至": "to",
    "发送验证码": "Send verification code",
    "余额（元": "Balance (yuan",
    "已到账": "Received",
    "输入金额不能小于1元": "The input amount cannot be less than 1 yuan",
    "近30天记录": "Record in recent 30 days",
    "未绑定": "Unbound",
    "审核中": "Under review",
    "关注/粉丝": "Follow/Fans",
    "银行卡": "bank card",
    "我的签到": "My check-in",
    "请输入商品关键字": "Please enter product keywords",
    "综合": "comprehensive",
    "您还没有收货地址,请先添加收货地址": "You do not have a shipping address. Please add a shipping address first",
    "在线客服": "Online Service",
    "发给客服": "Send to customer service",
    "图片": "picture",
    "表情": "expression",
    "拍摄": "shot",
    "等待后台审核，审核通过后可以去我的回答里查看已回复的回答": "Wait for the background review. After passing the review, you can go to my answer to view the reply",
    "已关注": "Followed",
    "等待后台审核，审核通过后可以去我的回答里查看已发布的回答": "Wait for the background review. After the review, you can go to my answer to view the published answers",
    "立即使用": "Use now",
    "公司税号": "Company tax number",
    "请输入电子邮箱": "Please enter email address",
    "设置为默认抬头": "Set as default header",
    "支付结果": "Payment results",
    "退款\/售后": "Refund\/After Sales",
    "自取订单": "Self order",
    "待取货": "To be picked up",
    "我的资料": "My profile",
    "订单消息": "Order message",
    "暂无历史记录": "No history",
    "物流详情": "Logistics details",
    "请输入您的评价": "Please enter your review",
    "添加照片": "Add photos",
    "最多可上传9张": "Up to 9 pieces can be uploaded",
    "退款金额": "refund amount",
    "第二步：上传微信收款二维码": "Step 2=> Upload the WeChat collection QR code",
    "第三步：填写微信真实姓名": "Step 3=> Fill in the real name of WeChat",
    "我不想买了": "I don't want to buy",
    "信息填错了，重新拍": "The information is wrong, please take a new picture",
    "卖家缺货": "Seller is out of stock",
    "其他原因": "Other reasons",
    "退款(无需退货)": "Refund (no return required)",
    "售后类型": "After-sales type",
    "退款完成": "Refund completed",
    "请等待商家处理": "Please wait for the merchant to process",
    "售后关闭": "After-sales shutdown",
    "寄回地址": "Return address",
    "退款信息": "Refund information",
    "退款原因": "Refund reason",
    "退款编号": "Refund No",
    "退款凭证": "Refund voucher",
    "商家已退款": "Merchant refunded",
    "退款账户": "Refund account",
    "退款时间": "Refund time",
    "撤销申请": "Cancellation of application",
    "撤销申请成功": "Cancel the application successfully",
    "领券": "Get the voucher",
    "确认删除吗": "Are you sure to delete",
    "确认取消吗": "Are you sure to cancel",
    "请输入电话号码": "Please enter a phone number",
    "确定删除么": "Are you sure to delete",
    "手机号码验证修改": "Mobile number verification and modification",
    "审核拒绝": "Audit Reject",
    "证件号（护照/枫叶卡/驾照）：": "ID number:",
    "请输入证件号（护照/枫叶卡/驾照）": "Please enter (passport/maple leaf card/driver's license)",
    "提现金额,": "Cash withdrawal amount,",
    "发票人信息": "Invoicer information",
    "注册协议": "Registration Agreement",
    "页面更新": "Page update",
    "平台消息": "Platform message",
    "终身会员": "Lifetime membership",
    "还剩": "Remaining",
    "订单待评价": "Order to be evaluated",
    "您的评价将会给其他买家参考": "Your comments will be referred to other buyers",
    "确认提交": "Confirm submission",
    "中国大陆 +86": "Chinese Mainland+86",
    "中国香港 +852": "Hong Kong, China+852",
    "中国澳门 +853": "Macau, China+853",
    "中国台湾 +886": "Taiwan, China+886",
    "兑换时间": "Exchange time",
    "收入记录": "Revenue record",
    "兑换规则": "Exchange rules",
    "已付款，等待卖家发货": "Paid, waiting for the seller to ship",
    "卖家已发货等待买家收货": "The seller has delivered the goods and is waiting for the buyer to receive the goods",
    "输入税号有误": "The tax number entered is incorrect",
    "应付款": "Accounts payable",
    "—— 我也是有底线的 ——": "——I also have a bottom line——",
    "设为默认地址": "Set as default address",
    "提现收取": "Cash withdrawal collection",
    "的手续费": "Service charge of",
    "使用权限=> 满": "Permission=> full",
    "特价专区": "special offer",
    "成长值：": "Growth value:",
    "点击登录\/注册": "Click Login\/Register",
    "K币余额": "Balance in K currency",
    "我的邀请": "My invitation",
    "我的发布": "My Publishing",
    "我的点赞": "My likes",
    "由于该用户隐私设置，粉丝列表不可见": "Due to the user's privacy settings, the fan list is not visible",
    "我的粉丝": "My fans",
    "我的关注": "My attention",
    "幸运抽奖": "Lucky Draw",
    "保存图片到相册": "Save picture to album",
    "欠款总额": "Total arrears",
    "常用功能": "Common functions",
    "团队推广": "Team promotion",
    "功能暂未开发": "The function has not been developed yet",
    "论坛": "Forum",
    "游戏": "Game",
    "升级后可享更多会员权益": "You can enjoy more membership benefits after upgrading",
    "恭喜中奖": "Congratulations on winning the prize",
    "抽奖记录": "Raffle record",
    "可前往至“我的k币“中心查看": "You can go to the \"My k coins\" center to view",
    "姿势不对?": "Wrong posture?",
    "查看我的k币": "View my k coins",
    "实物商品请申请邮寄": "Please apply for mailing physical goods",
    "申请邮寄": "Application mailing",
    "查看我的优惠券": "View my coupons",
    "抽到": "Draw",
    "已发放至我的k币": "The k coins that have been issued to me",
    "已发放至我的优惠券": "Coupons issued to me",
    "已发放": "Issued",
    "申请发货": "Apply for shipment",
    "发货申请提交成功，请耐心等待。如有疑问，可联系客服咨询。": "Delivery application submitted successfully, please wait patiently. If you have any questions, please contact customer service.",
    "知道了": "got it",
    "k币": "K coins",
    "实物": "material object",
    "提交成功": "Submitted successfully",
    "搜索用户昵称": "Search user nickname",
    "人": "people",
    "获取验证码:": "Obtain verification code:",
    "图形验证码:": "Graphic verification code:",
    "换一个": "Change it",
    "当前手机号码:": "Current phone number:",
    "短信验证码:": "SMS verification code:",
    "相互关注": "Mutual attention",
    "s后重新获取:": "Retrieve after s:",
    "回关": "Returning to Guan",
    "审核失败": "Audit failed",
    "已发布": "Published",
    "公司邮箱": "Company mailbox",
    "获取客服电话失败": "Failed to obtain customer service phone number",
    "唤起拨号失败,请确认已开通相关权限": "Call to dial failed. Please confirm that the relevant permissions have been opened",
    "期": "stage",
    "分期规则": "Staging rules",
    "还款订单号": "Repayment order No",
    "应付首付": "Down payment payable",
    "支付日期": "Payment date",
    "缴纳日期": "Payment date",
    "待支付": "To be paid",
    "已支付": "Paid",
    "已逾期": "Overdue",
    "搜索你想要的信息": "Search for the information you want",
    "推荐": "recommend",
    "选择话题": "Select topic",
    "内容描述": "Content description",
    "请对您的想法进行简单的描述吧～（200字以内）": "Please give a brief description of your idea~(within 200 words)",
    "请上传图片，最多上传": "Please upload pictures, upload at most",
    "全部评论": "All comments",
    "回复": "reply",
    "已点赞": "Like",
    "留下你的精彩评论吧": "Leave your wonderful comments",
    "展开": "open",
    "条回复": "Replies",
    "点赞成功": "Like succeeded",
    "取消点赞": "Cancel likes",
    "点赞失败": "Like failed",
    "举报详情": "Reporting details",
    "举报内容不能为空": "Report content cannot be empty",
    "请选择举报问题的类型": "Please select the type of reporting problem",
    "请先输入评论内容": "Please enter comments first",
    "电话": "Telephone",
    "粉丝": "fans",
    "购买了此商品": "Purchased this item",
    "分期付款": "hire purchase",
    "选择分期付款": "Select Installment",
    "2期  价格上涨10%  首付50%": "Phase 2 price increases by 10% and the down payment is 50%",
    "2期  价格上涨5%  首付80%": "Phase 2 price increases by 5% and down payment by 80%",
    "3期  价格上涨20%  首付50%": "Phase 3 price increase 20%, down payment 50%",
    "3期  价格上涨10%，首付80%": "The price of Phase 3 increased by 10% and the down payment was 80%",
    "1期支付": "Phase 1 payment",
    "2期支付": "Phase 2 payment",
    "3期支付": "3 installments",
    "分期明细": "Installment details",
    "服务器错误，请稍后重试": "Server error, please try again later",
    "平台收货": "Platform receiving",
    "同意售后": "Agree on after-sales service",
    "售后完成": "After-sales completion",
    "售后驳回": "After-sale rejection",
    "退货": "return goods",
    "订单待付尾款": "Order balance to be paid",
    "待付定金": "Deposit to be paid",
    "(先生)": "(Sir)",
    "(女士)": "(Madam)",
    "请输入银行卡号码": "Please enter the bank card number",
    "请上传选民卡照片": "Please upload the photo of voter card",
    "上传选民卡": "Upload voter card",
    "请选择所在地区": "Please select the region",
    "请填写详细地址": "Please fill in the detailed address",
    "已付尾款": "Balance paid",
    "待付尾款": "Balance to be paid",
    "商品已经下架了": "The goods are off the shelf",
    "售后申请已提交": "After-sales application has been submitted",
    "请选择退款原因": "Please select the refund reason",
    "填写注销申请": "Fill in cancellation application",
    "提供的信息有误": "The information provided is incorrect",
    "加入购物车": "add to cart",
    "+ 关注": "+Attention",
    "重置": "resetting",
    "审核中,您发布的论坛申请已提交，届时我们会在1-3个工作日对您提交的信息进行审核": "During the review, your forum application has been submitted. At that time, we will review the information you submitted in 1-3 working days",
    "确定删除该动态": "OK to delete this dynamic",
    "账号注销": "Account cancellation",
    "永久注销且无法恢复，请谨慎操作": "Permanent logout and unrecoverable, please be careful",
    "我已清除风险，确定继续": "I have cleared the risk, confirm to continue",
    "请选择注销账号的原因：": "Please select the reason for canceling the account:",
    "请填写注销原因：": "Please fill in the reason for cancellation:",
    "1、账号信息、第三方授权信息将被清空且无法恢复。": "1. Account information and third-party authorization information will be cleared and cannot be recovered.",
    "2、账号相关信息将会一并被删除且无法恢复。": "2. The account information will be deleted and cannot be recovered.",
    "3、注销后手机号码可重新注册，所生成账号为全新的账号，不包含注销账号的任何信息。": "3. After cancellation, the mobile phone number can be re-registered. The generated account is a new account and does not contain any information about the cancellation account.",
    "点击下方按钮，即表示你已阅读并了解以上风险": "By clicking the button below, you have read and understood the above risks",
    "我已清楚风险，确定继续": "I'm aware of the risks and determined to continue",
    "请再次确认，你已了解注销风险，并要继续执行该操作": "Please confirm again that you have understood the risk of cancellation and want to continue with the operation",
    "注销申请提交成功": "Cancellation application submitted successfully",
    "我们工作人员将会对您的账号进行审核，审核通过后，账号将会被注销，请知悉": "Our staff will review your account. After the review, the account will be cancelled. Please note",
    "请输入密码(6-12位字母+数字)": "Please enter the password (6-12 letters+numbers)",
    "联系我们": "contact us",
    "语言切换": "Language switching",
    "账号与安全": "Account and security",
    "注销账号": "Account cancellation",
    "拒绝原因": "Reason for rejection",
    "逾期金额：": "Overdue Amount:",
    "逾期期数：": "Number of overdue periods:",
    "支付失败,原因为=>": "",
    "犇腾家平台服务协议及隐私政策 =>": "",
    "备货中": "",
    "抽奖中": "",
    "已参与抽奖": "",
    "已参与": "",
    "注销后无法恢复}请谨慎操作!": "",
    "已经很干净了，没有需要清理的内容!": "",
    "据预售结束": "",
    "该商品暂无评论": "",
    "件已定": "The item has been finalized",
    "参与拼单": "Participate in order consolidation",
    "参与": "participate in",
    "这些人刚刚购买成功可直接参与拼单": "",
    "拼主": "Pinzhu",
    "全部拼单": "Complete consolidation",
    "这是您发起的拼团": "",
    "的拼单": "Collaborating orders",
    "原价": "",
    "个人拼成，拼团成功": "",
    "拼团中}还差": "",
    "已选择该商品，开始砍价": "",
    "已砍价成功": "",
    "仅限": "",
    "个名额": "",
    "立即砍价": "",
    "帮他砍一刀": "",
    "邀请好友砍一刀": "",
    "借你大刀砍一砍~": "",
    "恭喜你}砍价成功": "",
    "你帮砍后}好友砍成概率达": "",
    "剩": "",
    "秒": "",
    "设置成功}将在开抢前收到提醒": "",
    "秒杀提醒已取消}您可能会抢不到": "",
    "您还没有收货地址}去添加": "",
    "使用": "",
    "请输入详细地址：如道路、门牌号、小区、楼栋号等": "",
    "选择所在地区": "",
    "默认地址": "",
    "河南省": "",
    "郑州市": "",
    "本月订单": "",
    "累计订单": "",
    "今日收益": "",
    "总推广人数": "",
    "本月收益": "",
    "全部人员": "",
    "直推人员": "",
    "间推人员": "",
    "我的直推": "",
    "我的间推": "",
    "推广人统计": "",
    "人员等级": "",
    "谢谢你，帮我砍一刀": "",
    "订单明细": "",
    "我来回答": "I'll answer",
    "全场通用": "",
    "详细信息": "",
    "· 不能和其他优惠券叠加使用": "",
    "· 所有新品上架都能使用": "",
    "商家回复": "",
    "新品": "New product",
    "请输入商品名称": "Please enter the product name",
    "人关注": "People follow",
    "关注成功": "Follow Success",
    "取消关注": "Cancel Follow",
    "指定商品可用": "",
    "支付密码为6位数字，用户提现、设置密保、添加银行卡等操作，可保障资金安全": "",
    "请设置新密码}用于支付验证": "",
    "请再次输入}以确认密码": "",
    "请输入支付密码 以验证身份": "Please enter the payment password to verify your identity",
    "请设置新支付密码": "Please set a new payment password",
    "确认注销": "",
    "账号注销后将放弃以下权益": "",
    "我已阅读并同意以上协议": "I have read and agree to the above agreement",
    "请勾选同意协议后操作": "",
    "请选择注销原因": "Please select the reason for cancellation",
    "处理中": "Processing",
    "通过后，账号将会被注销，请知悉": "",
    "我们工作人员将会对您的账号进行审核，审核": "",
    "反馈内容": "",
    "问题描述的越详细.有助于我们更快的解决问题（200字以内）": "",
    "联系方式中不能包含中文": "",
    "请选择语言": "",
    "该商品已兑换完了}看看其它的吧": "",
    "提交成功}正在为您取消订单": "",
    "已提醒}请耐心等待": "",
    "支付失败}原因为": "",
    "开票中": "In invoicing",
    "预计发票金额": "",
    "增值税电子普通发票": "Value added tax electronic ordinary invoice",
    "下载发票": "Download invoice",
    "开票金额说明": "",
    "空": "",
    "·开票金额为消费者实付金额。·现展示为订单预计开票金额，最终金额以发票实际开具为准": "",
    "发票链接有误": "",
    "下载中...": "",
    "暂无直播": "",
    "直播中": "",
    "未开始": "",
    "已结束": "",
    "禁播": "",
    "暂停中": "",
    "异常": "",
    "确认要离开收银台": "",
    "内未支付将被取消}请尽快完成支付": "",
    "支付失败}请稍后重试": "",
    "混合支付 - 微信支付失败": "",
    "支付失败}原因为=> ": "",
    "查看会员": "",
    "您当前未开通会员": "",
    "有效期": "",
    "开通会员享更多优惠": "",
    "会员专属标识，可续费延长": "",
    "含发货运费": "",
    "含优惠券": "",
    "元，不可修改": "",
    "失败": "fail",
    "我的砍价": "",
    "砍价失败": "",
    "就可最低价拿走": "",
    "撤销时间": "Revocation time",
    "砍价成功": "",
    "砍价中": "Bargaining",
    "恭喜您！砍价成功": "",
    "很遗憾，砍价失败": "",
    "重新发起": "Reissue",
    "等待商家发货": "",
    "您已撤销本次售后申请，如有问题未解决，您可重新发起申请": "",
    "您已成功发起补货申请，请耐心等待平台处理。": "",
    "商家同意，系统将退款给您": "",
    "如商家拒绝，您可以修改申请后再次发起，商家会重新处理。": "If the merchant refuses, you can modify the application and initiate it again, and the merchant will process it again.",
    "请寄回商品": "Please send back the goods",
    "请等待商家退款": "Please wait for the merchant's refund",
    "商家已同意退货申请，请寄回商品并提交物流信息。": "The merchant has agreed to the return request. Please return the goods and submit the logistics information.",
    "商品已寄回，请等待商家收货并退款。": "",
    "商家同意后，请按照给出的退货地址退货，并请填写退货运单号进行提交。": "After the merchant agrees, please return the goods to the provided return address and fill in the return waybill number for submission.",
    "未与商家协商一致，请勿使用到付或者平邮，以免商家拒收。": "",
    "如果商家收到货并验货无误，将操作退款给您。钱款原路返回至您支付时选择的账户。": "If the merchant receives the goods and verifies them to be correct, they will process a refund to you. The money will be returned to the account you selected when making the payment.",
    "请填写真实的退货物流信息，逾期未填写，退货申请将自动关闭。": "Please provide the true return logistics information. If not filled out within the deadline, the return application will be automatically closed.",
    "等待收货": "",
    "平台已发货，等待收货": "",
    "平台已同意补货申请}等待平台发货": "",
    "如果收到货并验货无误，请点击确认收货": "",
    "拼团订单待付款": "",
    "联系平台": "Contact platform",
    "平台审核": "",
    "平台发货": "",
    "补货": "",
    "确认删除吗？": "",
    "确认取消吗？": "",
    "发起售后": "",
    "为了给您更优的退换货时效和体验，我公司建议优先选择协作快递韵达。": "",
    "请填写物流单号": "Please fill in the logistics tracking number",
    "请填写联系电话": "Please fill in the contact phone number",
    "退换说明": "Return and exchange instructions",
    "请输入(选填)": "Please enter (optional)",
    "物流信息已提交售后}等待商家审核": "",
    "上传失败}请检查网络设置": "",
    "时自动确认": "",
    "暂无相关内容": "",
    "已付定金": "Deposit paid",
    "件商品": "Items",
    "取消成功": "Cancel successful",
    "交易关闭": "Transaction closure",
    "寄回待取货商品": "",
    "待审核": "Pending review",
    "待寄回": "To be sent back",
    "待退款": "Pending refund",
    "商家配送": "",
    "物流配送": "",
    "用户自取": "",
    "您还没有选泽自取人}去选择": "",
    "您还没有选中自取点}去选择": "",
    "预售商品定金不退哦": "",
    "暂无时间范围点": "",
    "预售商品定金不支持退款}同意后可继续下单.": "",
    "抱歉，以下商品无法下单购买": "",
    "更改收货地址": "",
    "返回上一页": "Go back to the previous page",
    "查看更多": "View more",
    "亲，这个时间段没有要秒杀的商品噢": "",
    "点场": "",
    "成长值": "",
    "商品收藏": "",
    "浏览足迹": "",
    "查看权益": "",
    "我的地址": "",
    "提货列表": "",
    "累计": "",
    "请填写注销原因": "Please fill in the reason for cancellation",
    "请输入~": "",
    "问题描述的越详细.有助于我们更快的解决问题（300字以内）": "",
    "邮箱验证修改": "",
    "个性化": "",
    "个性化内容推荐": "Personalized content recommendation",
    "关闭以停止接收个性化内容建议": "",
    "APP打开时": "When the app is opened",
    "新消息系统通知": "New message system notification",
    "开启后可收到消息通知": "",
    "为了更好的服务，APP会请求您的权限。": "",
    "位置信息": "position information",
    "根据您的位置为您推荐周边的服务": "Recommend nearby services based on your location",
    "相机权限": "Camera permissions",
    "实现拍照、录视频": "Implement photography and video recording",
    "存储权限": "Storage permissions",
    "用于图片和视频的上传": "",
    "通知设置": "Notification settings",
    "权限设置": "Permission settings",
    "用户注册指南": "",
    "提醒": "",
    "订单提交成功,请耐心等待批准": "",
    "您还没有选择自取人,去选择": "",
    "实际付款": "",
    "请输入正确手机号": "",
    "验证码发送成功，请注意查收": "",
    "请正确输入邮箱": "",
    "请输入名字": "",
    "请输入姓氏": "",
    "请输入公司名称": "",
    "请选取": "",
    "猜你喜欢": "Guess you like it",
    "成功为他们省了": "",
    "评级": "",
    "运费详情": "",
    "活跃值解锁": "",
    "达到": "",
    "特权": "",
    "收益明细": "",
    "取货人": "",
    "设置默认取货人": "",
    "取货人列表": "",
    "设为默认取货人": "",
    "默认取货人": "",
    "您还未添加任何地址": "",
    "购买数量": "Purchase quantity",
    "剩于": "",
    "结算时间": "",
    "结算类型": "",
    "备注说明": "",
    "砍单记录": "",
    "已砍至": "",
    "倒计时": "",
    "活动结束": "",
    "取消活动": "",
    "活动进行中": "",
    "拼团中，剩余时间": "",
    "立即升级": "",
    "升级会员尊享优惠！预估额外再省": "",
    "下单返，转发赚，开通会员更享优惠": "",
    "输入邀请码": "",
    "您还未绑定过邀请人哦": "",
    "一键分享": "",
    "发起免单": "",
    "刚刚购买了此商品": "",
    "已砍掉": "",
    "好友已砍价成功": "",
    "确认取消砍价吗": "",
    "为您推荐": "",
    "新品上架": "",
    "领券中心": "",
    "服务": "",
    "修改绑定邮箱": "",
    "评价详情": "",
    "关注\/粉丝": "",
    "秒杀规则": "",
    "请输入评论信息": "",
    "请输入您要评论的内容": "",
    "不参与任何活动": "",
    "新邮箱中不能包含中文": "",
    "请选择州": "",
    "请先选择国家": "",
    "请先选择州": "",
    "订单生成中": "",
    "互相关注": "Mutual attention",
    "快来下载威胜科技,体验更多优惠": "",
    "您的好友": "",
    "最近浏览": "",
    "含税费": "",
    "优惠金额": "",
    "优惠方式": "",
    "税": "",
    "请输入收货人姓氏": "",
    "请输入收货人名字": "",
    "每日活动": "",
    "晒单列表": "",
    "晒单": "",
    "稍后购买": "",
    "个人主页": "",
    "中国": "",
    "姓": "",
    "名": "",
    "邮编": "",
    "州": "",
    "城市": "",
    "超出限购数量": "",
    "抱歉，该商品超出限购数量": "",
    "图文详情内容": "",
    "热销排行": "",
    "限量": "",
    "请输入正确的邮箱号": "",
    "请输入新邮箱": "",
    "请输入原邮箱": "",
    "请填写正确的新邮箱": "",
    "公司简介": "",
    "确认加入购物车吗": "",
    "今日免费次数已用完": "",
    "您的积分不足，分享好友可获得一次机会": "",
    "分享好友可获得一次机会": "",
    "今日开盲盒次数已用完，明天再来吧": "",
    "请选择要加入购物车的商品": "",
    "帮助与反馈": "Help and feedback",
    "权限管理": "Permission management",
    "待平台收货": "",
    "为了向您提供更好的用户体验": "In order to provide you with a better user experience",
    "APP会在特定场景下向您申请一下手机系统权限": "The APP will apply for mobile system permissions from you in specific scenarios",
    "关闭后无法收到个性化内容推荐": "Unable to receive personalized content recommendations after closing",
    "个性化推荐设置": "Personalized recommendation",
    "消息通知设置": "Message notification settings",
    "稍后购买清单": "",
    "距本场结束仅剩": "",
    "盲盒已开完，请明天再开": "",
    "请输入6-12位旧密码": "",
    "请输入6-12位新密码": "",
    "问题描述的越详细，有助于我们更快的解决问题": "The more detailed the problem description is, the faster it will help us solve the problem",
    "应退金额": "",
    "会员打折优惠": "",
    "找好友代付": "",
    "折扣码优惠": "",
    "输入折扣码": "",
    "折扣码": "",
    "订单提交成功": "",
    "绑定新邮箱": "",
    "请输入新的邮箱": "",
    "新邮箱地址": "",
    "原邮箱": "",
    "新邮箱": "",
    "平台已同意补货申请,等待平台发货": "",
    "热销榜单": "",
    "期间限定": "",
    "平台精选": "",
    "物流编号": "",
    "余额不足": "",
    "自动确认": "Automatic confirmation",
    "订单已关闭": "Order closed",
    "申请售后_t": "",
    "请选择完整的地址": "",
    "反馈内容不能输入表情": "",
    "选择地址": "",
    "您的姓名": "",
    "请输入您的姓名": "",
    "您的邮箱": "",
    "问题描述": "Problem description",
    "问题描述的越详细,有助于我们更快的解决问题": "",
    "请上传应用截图,最多可上传6张": "",
    "原路退回": "",
    "请输入想要搜索的商品": "",
    "使用权限=>": "",
    "请阅读并同意协议": "",
    "请选择一个标签": "",
    "正在发起支付": "",
    "找朋友付": "",
    "请输入联系电话": "Please enter the contact phone number",
    "请输入正确的联系电话": "Please enter the correct contact phone number",
    "退货运费": "",
    "实际退款": "",
    "密码不能包含中文": "",
    "个人中心1": "",
    "请输入新密码(6-12位)": "",
    "商品类别": "",
    "全部品牌": "",
    "只看打折": "",
    "折扣方式": "",
    "确定撤销申请吗？": "",
    "已加载全部内容": "",
    "暂无内容": "",
    "消费满": "",
    "分享订单": "",
    "商品资讯": "",
    "该收货地址不在配送范围": "",
    "搜索昵称": "",
    "好评": "Positive reviews",
    "功能": "",
    "我们要对您绑定的邮箱进行验证": "",
    "我的折扣券": "",
    "折扣券": "",
    "选择折扣券": "",
    "折": "",
    "资讯": "",
    "设备": "",
    "搜索您想要的商品": "",
    "未注册邮箱验证后自动创建平台账号": "",
    "恭喜您开出": "",
    "查看优惠券": "",
    "点击免费摇盲盒": "",
    "日本": "",
    "美国": "",
    "我们要对您绑定的账号进行验证": "",
    "秒杀秘籍": "",
    "限时抢购": "",
    "请输入名称": "",
    "请上传图片": "Please upload pictures",
    "此商品无法购买": "",
    "点击过快，请稍后再试": "",
    "线上支付": "",
    "线下支付": "",
    "收集信息": "",
    "收信人姓名": "",
    "支付信息": "Payment information",
    "名称": "",
    "请输入您的真实姓名": "",
    "请输入您的国家名称": "",
    "存款银行": "",
    "请进入银行办理转移": "",
    "请输入您的银行卡数量": "",
    "付款凭证(最多6张)": "",
    "立即付款": "",
    "请输入存款银行": "",
    "请输入银行账号": "",
    "请上传支付凭证": "",
    "审核被拒绝": "",
    "种草": "recommend",
    "请输入正确的密码（6~12位字母+数字）": "Please enter the correct password (6-12 letters+numbers)",
    "请勾选协议": "Please check the agreement",
    "请阅读并勾选《用户注册协议》和《隐私政策》": "Please read and check 《the User Registration Agreement 》and 《Privacy Policy》",
    "新犇腾家  |  人性化电商领跑者": "Xinbenteng Home | A leader in humanized e-commerce",
    "更多": "more",
    "进店": "Entering the store",
    "￥": "$",
    "超值拼团": "Value Pack",
    "人团": "A group of people",
    "分享赚": "Share to earn",
    "邀请码：": "Invitation code:",
    "请登录": "Please log in",
    "距离下次升级": "Distance to next upgrade",
    "足迹": "footprint",
    "全部订单": "All orders",
    "商家入驻": "Merchant settlement",
    "奖品记录": "Prize Record",
    "我的主页": "My homepage",
    "待认证审核": "Pending certification review",
    "我的店铺": "personal stores",
    "认证审核失败": "Certification review failed",
    "待财务审核": "Pending financial review",
    "财务审核失败": "Financial review failed",
    "待提交财务凭证": "Financial vouchers to be submitted",
    "请通过链接下载商家端app": "Please download the merchant app through the link",
    "发现": "find",
    "正文和评论": "Main text and comments",
    "条评论": "Comments",
    "回复：": "Reply:",
    "说点什么吧，万一火了呢~": "Say something, what if it gets hot~",
    "分享至": "Share to",
    "生成分享图": "Generate sharing image",
    "举报": "report",
    "已互关": "Interrelated",
    "视频发布": "Video publishing",
    "图文发布": "Image and text release",
    "请输入正确的验证码": "Please enter the correct verification code",
    "请输入邀请码（选填）": "Please enter the invitation code (optional)",
    "已开启": "Opened",
    "用于图片或视频的上传": "Used for uploading images or videos",
    "开启后，可收到消息通知": "After activation, you can receive message notifications",
    "反馈类型：": "Feedback type:",
    "反馈时间：": "Feedback time:",
    "平台回复：": "Platform response:",
    "请选择反馈类型": "Please select feedback type",
    "请输入问题描述": "Please enter a description of the problem",
    "注销申请提交成功！": "Cancellation application submitted successfully!",
    "我们工作人员将会对您的账号进行审核，审核通过后， 账号将会被注销，请知悉": "Our staff will review your account, and once it is approved, the account will be cancelled. Please be informed",
    "注销理由：": "Reason for cancellation:",
    "注销驳回": "Cancellation rejection",
    "重新申请": "Reapply",
    "请输入您的反馈": "Please enter your feedback",
    "账号注销后将放弃以下权益：": "After account cancellation, the following rights will be waived:",
    "请再次确认，你已了解注销风险， 并要继续执行该操作": "Please confirm again that you are aware of the cancellation risk and wish to continue with the operation",
    "我们要对您绑定的手机号进行验证：": "We need to verify the phone number you have bound:",
    "请输入正确的新密码（6~12位字母+数字）": "Please enter the correct new password (6-12 letters+numbers)",
    "请输入确认密码": "Please enter a confirmation password",
    "请输入正确的确认密码（6~12位字母+数字）": "Please enter the correct confirmation password (6-12 letters+numbers)",
    "两次输入密码不一致": "The passwords entered twice are inconsistent",
    "请输入正确的旧密码（6~12位字母+数字）": "Please enter the correct old password (6-12 letters+numbers)",
    "支付密码为6位数字，用户提现、设置密保、添加银行卡等 操作，可保障资金安全": "The payment password is a 6-digit number, which allows users to withdraw funds, set security, add bank cards, and other operations to ensure fund security",
    "新密码两次输入不一致": "The new password entered twice is inconsistent",
    "旧密码与新密码不能一致": "Old password and new password cannot match",
    "尚未设置支付密码？是否前往设置": "Have you not set a payment password yet? Do you want to go to the settings",
    "黑名单": "Blacklist",
    "个性化推送设置": "Personalized push settings",
    "被拉黑的用户无法关注你或无法看到你的个人主页以及动态": "Blacklisted users are unable to follow you or see your personal homepage and updates",
    "请输入ID或昵称": "Please enter your ID or nickname",
    "帖子": "Posts",
    "请输入店铺名称": "Please enter the store name",
    "店铺": "shop",
    "距离": "distance",
    "热销TOP榜": "Hot selling TOP list",
    "全部商品": "All products",
    "商品分类": "Product classification",
    "自购返：": "Self purchase return:",
    "分享赚：": "Share to earn:",
    "批发价：": "Wholesale price:",
    "件起购": "Minimum purchase quantity",
    "通用｜": "Universal |",
    "折扣说明": "Discount Description",
    "已选：": "Selected:",
    "请选择规格": "Please select a specification",
    "暂无地址": "No address currently available",
    "优惠套餐(": "Discount Package（",
    "商品评价(": "Product evaluation（",
    "进店逛逛": "Enter the store for a stroll",
    "商品已下架": "The product has been delisted",
    "套餐": "Package",
    "购买此套餐": "Purchase this package",
    "保存失败": "Save failed",
    "请输入评论": "Please enter a comment",
    "请输入您的问题": "Please enter your question",
    "确认支付密码": "Confirm payment password",
    "请再次输入支付密码": "Please enter the payment password again",
    "两次密码输入不一致": "The two password inputs are inconsistent",
    "已发放至积分账户": "Distributed to points account",
    "已申请邮寄": "Applied for mailing",
    "请确认登录密码": "Please confirm the login password",
    "密码输入不一致": "Inconsistent password input",
    "确定收货": "Confirm receipt",
    "收货地址": "receiving address",
    "预售待付尾款": "Pre sale outstanding balance",
    "特价": "Special offer",
    "转账详情": "Transfer details",
    "商家已收货": "Merchant has received the goods",
    "抬头选择": "Head up selection",
    "联系邮箱": "Contact email",
    "添加新的抬头": "Add new header",
    "确定删除订单？": "Are you sure to delete the order?",
    "剩余时间：": "Remaining time:",
    "尾款支付时间 :": "Final payment time:",
    "会员折扣": "Member discount",
    "-￥": "-$",
    "物流公司：": "Logistics company:",
    "物流单号：": "Logistics tracking number:",
    "为了给您更优的退换货时效和体验，我公司建议优先选择 协作快递韵达。": "In order to provide you with a better return and exchange time and experience, our company suggests prioritizing the use of collaborative express delivery, Yunda.",
    "请输入买家发货运单号": "Please enter the buyer's shipping waybill number",
    "请填写联系方式": "Please provide contact information",
    "请选择售后类型": "Please select the after-sales type",
    "退款数量": "Refund quantity",
    "退款金额：": "Refund amount:",
    "不包含运费": "Excluding shipping costs",
    "请填写退款说明": "Please fill in the refund instructions",
    "您已成功发起退款申请，请耐心等待商家处理。": "You have successfully initiated a refund request. Please be patient and wait for the merchant to process it.",
    "未与商家协商一致，请勿使用到到付或平邮，以免商家拒收。": "Please do not use collect or surface mail without reaching an agreement with the merchant to avoid rejection.",
    "商品已寄回，请等待商家收货并退款": "The product has been returned, please wait for the merchant to receive it and receive a refund",
    "商家同意，系统将退款给您 如商家拒绝，您可以修改申请后再次发起，商家会重新处理。": "The merchant agrees, and the system will refund you. If the merchant refuses, you can modify the application and initiate it again. The merchant will process it again.",
    "售后拒绝": "After sales rejection",
    "拒绝原因:": "Reason for rejection:",
    "商家已拒绝您的申请": "The merchant has rejected your application",
    "寄回信息": "Sending back information",
    "系统提示": "System prompt",
    "件 合计:": "Total number of items:",
    "平台优惠券": "Platform coupons",
    "总计：": "Total:",
    "切换收货地址": "Switch shipping address",
    "请选择地址": "Please select an address",
    "多包裹": "Multiple packages",
    "包裹": "package",
    "发票作废": "Invoice Void",
    "预计发票金额：￥": "Estimated invoice amount:$",
    "订单": "order form",
    "发票说明": "Invoice Description",
    "联系方式不能为空": "Contact information cannot be empty",
    "请输入正确的联系方式": "Please enter the correct contact information",
    "请输入正确的邮箱": "Please enter the correct email address",
    "请输入公司税号": "Please enter the company tax number",
    "公司": "company",
    "请输入企业单位税号": "Please enter the enterprise unit tax number",
    "发票管理": "control over invoices",
    "默认发票": "Default invoice",
    "确定删除该发票？": "Are you sure to delete this invoice?",
    "请选择性别": "Please select gender",
    "选择日期": "Select date",
    "昵称最多7个字符": "Nickname can have up to 7 characters",
    "会员中心": "Member Center",
    "距离下次升级还差": "We're still far from the next upgrade",
    "等级规则及权益": "Level rules and benefits",
    "开始时间": "start time",
    "结束时间": "End time",
    "累计返佣（元）": "Accumulated commission rebate (yuan)",
    "本日返佣(元)": "Today's commission refund (yuan)",
    "本周返佣(元)": "This week's commission refund (yuan)",
    "本月返佣(元)": "Return commission for this month (yuan)",
    "上月返佣(元)": "Last month's commission rebate (yuan)",
    "获利明细": "Profit details",
    "我的余额": "My balance",
    "起提金额：100元，提现收取": "Withdrawal amount: 100 yuan, withdrawal collection",
    "还未绑定微信,是否前往绑定?": "WeChat has not been bound yet. Do you want to go and bind it?",
    "还未绑定支付宝,是否前往绑定?": "Alipay has not been bound yet, do you want to bind it?",
    "还未绑定银行卡,是否前往绑定?": "Bank card has not been bound yet. Do you want to go and bind it?",
    "是否前往设置支付密码？": "Do you want to go and set a payment password?",
    "持卡人姓名": "Cardholder Name",
    "请输入正确的银行卡": "Please enter the correct bank card",
    "请上传二维码": "Please upload the QR code",
    "总金额（元）": "Total amount (yuan)",
    "冻结金额（元）": "Freeze amount (yuan)",
    "可提现余额（元）": "Withdrawable balance (yuan)",
    "冻结金额规则": "Freeze Amount Rule",
    "状态：": "Status:",
    "自定义输入金额": "Custom input amount",
    "可提现金额": "Withdrawable amount",
    "全部人员(": "All personnel（",
    "直推人员(": "Direct promotion personnel（",
    "间推人员(": "Interpersonal promotion personnel（",
    "分销规则说明": "Distribution Rule Description",
    "，预计获得返佣": "Expected to receive commission rebate",
    "同意商家入驻协议": "Agree to Merchant Entry Agreement",
    "下一步，填写申请信息": "Next, fill in the application information",
    "选择套餐": "Choose Package",
    "选择开店套餐": "Choose a store package",
    "最大商品添加数量": "Maximum product addition quantity",
    "平台抽成比例": "Platform commission ratio",
    "法人身份证国徽面": "Corporate ID card with national emblem",
    "法人身份证人面像": "Face image of legal representative witness",
    "身份证人像面": "Identity witness profile",
    "上一步": "Previous step",
    "请选择类型": "Please select the type",
    "请上传身份证国徽面": "Please upload the national emblem on your ID card",
    "请上传身份证人像面": "Please upload a portrait of the identity witness",
    "请选择公司所在地": "Please select the location of your company",
    "请输入公司详细地址": "Please enter your company's detailed address",
    "请输入社会统一信用码": "Please enter the social unified credit code",
    "请上传营业执照": "Please upload your business license",
    "请输入经营范围": "Please enter the business scope",
    "结算信息": "Settlement information",
    "请选择结算类型": "Please select the settlement type",
    "请输入结算账户": "Please enter the settlement account",
    "请输入正确的银行卡号": "Please enter the correct bank card number",
    "请输入银行卡开户名": "Please enter the bank card account opening name",
    "请输入结算开户银行支行名称": "Please enter the name of the settlement account opening bank branch",
    "请输入结算开户银行所在地": "Please enter the location of the settlement account opening bank",
    "请上传收款二维码": "Please upload the payment QR code",
    "店铺信息": "Store Information",
    "自营": "Self operated",
    "非自营": "Non self operated",
    "请填写店铺名称": "Please fill in the store name",
    "请上传店铺logo": "Please upload the store logo",
    "请上传店铺背景": "Please upload the store background",
    "请选择主营行业": "Please select the main industry",
    "请选择入驻时长": "Please select the duration of entry",
    "请选择店铺所在地地址": "Please select the address where the store is located",
    "请输入店铺简介": "Please enter the store introduction",
    "信息审核": "Information review",
    "审核成功": "Review successful",
    "请前往下载商家端app": "Please go to download the merchant app",
    "身份证国徽面": "Face of national emblem on ID card",
    "公司信息": "Company Information",
    "公司名称": "Company Name",
    "公司所在地": "country of domicile",
    "法人姓名": "Legal representative's name",
    "法人手机号": "Corporate phone number",
    "5044": "five thousand and forty-four",
    "法人身份证号": "Corporate ID number number",
    "结算账户": "Settlement account",
    "结算开户名": "Settlement account name",
    "结算开户银行支行名称": "Name of settlement account opening bank branch",
    "结算开户银行所在地": "Settlement account opening bank location",
    "请选择所在地址": "Please select your address",
    "请选择地址标签": "Please select the address label",
    "请输入收货人名称": "Please enter the recipient's name",
    "请选择省市区": "Please select a province, city or district",
    "确定删除该地址？": "Are you sure you want to delete this address?",
    "待成团": "To form a group",
    "拼团中，剩余时间：": "In the group, remaining time:",
    "已砍掉： ¥": "Cut off: ¥",
    "活动结束，砍价失败": "Event ended, bargaining failed",
    "订单待成团": "Order to be grouped",
    "拼团中，还差": "In the group, we're still short",
    "拼成，剩：": "Joined together, remaining:",
    "收款账号": "Receiving account",
    "收款户名": "Receiving account name",
    "请输入银行开户行": "Please enter the bank account opening bank",
    "收款银行": "Receiving bank",
    "打款金额": "Payment amount",
    "请输入打款金额": "Please enter the payment amount",
    "打款截图": "Screenshot of payment",
    "请上传打款截图": "Please upload a payment screenshot",
    "请输入打款备注": "Please enter payment notes",
    "已累计签到": "Accumulated check-in",
    "共获得": "Co obtained",
    "修改昵称": "Change nickname",
    "请设置2-7个字符，不包含@《\/等无效字符哦": "Please set 2-7 characters, excluding invalid characters such as @ and\/",
    "请输入新昵称": "Please enter a new nickname",
    "昵称不得超过七个字符": "Nickname cannot exceed seven characters",
    "请输入ID和昵称": "Please enter your ID and nickname",
    "请输入ID": "Please enter your ID ",
    "互关": "Interdependence",
    "收到的赞和收藏": "Received likes and collections",
    "了你的帖子": "Thank you for your post",
    "新增关注": "Add Follow",
    "了你": "You",
    "收到评论": "Received comments",
    "评论了你的帖子": "Reviewed your post",
    "更换背景图": "Replace background image",
    "回复评论": "Reply to comments",
    "说点什么……": "Say something",
    "获赞与收藏": "Likes and Collections",
    "赞过": "Like",
    "请输入回复内容": "Please enter the reply content",
    "幸运大抽奖": "Lucky Draw",
    "本地草稿箱": "Local draft box",
    "有1篇笔记待发布": "There is 1 note waiting to be published",
    "减": "reduce",
    "可前往至“": "You can go to“",
    "“查看": "View",
    "确认拉黑该用户吗？": "Are you sure you want to block this user?",
    "很遗憾，您未中奖": "Unfortunately, you did not win the prize",
    "谢谢惠顾，下次努力": "Thank you for your patronage. We will work hard next time",
    "当前发布帖子数": "Current number of posts published",
    "当前获得收藏数": "Current collection count",
    "搜索更多话题": "Search for more topics",
    "填写标题会有更多赞哦~": "Filling in the title will give you more likes~",
    "添加正文": "Add main text",
    "添加商品": "Add product",
    "参与话题": "Participate in the topic",
    "添加地点": "Add location",
    "存草稿": "Save Draft",
    "发布笔记": "Post notes",
    "小积分换大奖": "Exchange small points for big prizes",
    "积分+": "Integral+",
    "已购": "Purchased",
    "浏览": "browse",
    "已购宝贝": "Purchased items",
    "认证信息": "Certification information",
    "收藏的宝贝": "Collected treasures",
    "浏览的宝贝": "Browsed Baby",
    "已选开店套餐": "Selected store package",
    "申请信息": "Application Information",
    "确认保存笔记至草稿箱": "Confirm saving notes to the draft box",
    "公司详情地址": "Company Details Address",
    "发布须知": "Release Notice",
    "请上传视频": "Please upload a video",
    "请输入标题": "Please enter a title",
    "请输入帖子内容": "Please enter the content of the post",
    "请选择话题": "Please select a topic",
    "统一社会信用码": "Unified Social Credit Code",
    "请输入统一社会信用码": "Please enter a unified social credit code",
    "营业执照": "Business license",
    "法定经营范围": "Legal business scope",
    "TA的粉丝": "TA's fans",
    "请输入法定经营范围": "Please enter the legal business scope",
    "TA的关注": "TA's attention",
    "拉黑": "block",
    "当前获得点赞数": "Current likes received",
    "店铺名称": "Store Name",
    "店铺logo": "Store logo",
    "店铺背景": "Store Background",
    "经营方式": "Business model",
    "主营行业": "Main industry",
    "入驻时长": "Duration of entry",
    "保证金": "Margin",
    "服务费": "service charge",
    "最热": "The hottest",
    "店铺所在地": "Store location",
    "最新": "Latest",
    "店铺详细地址": "Detailed store address",
    "店铺简介": "Store Introduction",
    "客服电话": "customer service telephone numbers",
    "请输入客服电话": "Please enter customer service phone number",
    "用户": "user",
    "类型": "type",
    "请输入关键字": "Please enter keywords",
    "猜你想搜": "Guess you want to search",
    "商品积分(当前积分：": "Product points (current points:",
    "合计：": "Total:",
    "很抱歉,您的收货地址不在配送范围内": "Sorry, your shipping address is not within the delivery range",
    "积分：": "Points:",
    "是否确认删除订单?": "Are you sure to delete the order?",
    "是否确认收货?": "Are you sure you have received the goods?",
    "是否确认取消订单?": "Are you sure to cancel the order?",
    "兑换时间：": "Redemption time:",
    "应付金额：": "Payable amount:",
    "支付方式：": "Payment method:",
    "支付时间：": "Payment time:",
    "抢购": "Rush to purchase",
    "件已售": "Items sold",
    "元立减": "Yuan Li Jian",
    "立减": "Vertical reduction",
    "（选填）": "(Optional)",
    "图片证据": "Image evidence",
    "最多三张": "Up to three sheets",
    "请选择举报类型": "Please select the reporting type",
    "查看TA提到的商品": "View the products mentioned by TA",
    "赞和收藏": "Praise and Collection",
    "作者": "author",
    "展开更多回复": "Expand more replies",
    "TA提到的商品": "The products mentioned by TA",
    "请输入评论内容": "Please enter the comment content",
    "秒杀专区": "Flash sale zone",
    "商城头条": "Mall Headlines",
    "秒杀价": "Second price reduction",
    "距拼团结束仅剩": "End time remaining",
    "这些人刚刚购买成功，可直接参与拼单": "These people have just made a successful purchase and can directly participate in the consolidation process",
    "拼成": "Pieced together",
    "仅剩": "Only remaining",
    "个名额，": "A quota,",
    "阶段1：定金": "Stage 1: Deposit",
    "阶段2：尾款": "Stage 2: Final Payment",
    "(预售商品定金不退)": "(Non refundable deposit for pre-sale products)",
    "预售商品定金不支持退款，同意后可继续下单。": "The deposit for pre-sale products does not support refunds. Once approved, you can proceed with placing an order.",
    "距预售结束仅剩": "Only remaining until the pre-sale ends",
    "1.付定金-2.付尾款-3.发货": "1. Pay the deposit -2. Pay the final payment -3. Shipment",
    "%免费拿": "%Get it for free",
    "人已免费拿": "People have already taken it for free",
    "选择其他收货地址": "Choose another shipping address",
    "确认收货地址，免费拿商品": "Confirm the shipping address and receive the product for free",
    "支付剩余时间：": "Payment remaining time:",
    "确认要离开收银台？": "Are you sure you want to leave the cashier?",
    "内未支付将被取消，请尽快完成支付": "Unpaid payment will be cancelled. Please complete the payment as soon as possible",
    "请选择支付方式": "Please select payment method",
    "砍价详情": "Details of bargaining",
    "关闭展开更多": "Close Expand More",
    "删除后无法查看、恢复，是否确认。": "After deletion, it cannot be viewed or restored. Are you sure.",
    "是否确认删除": "Are you sure you want to delete it",
    "我们工作人员将会1-3个工作日对您的账号进行审核，审核通过后， 账号将会被注销，请知悉": "Our staff will review your account within 1-3 working days. Once approved, your account will be cancelled. Please be informed",
    "1-3个工作日内通知审核结果": "Notify audit results within 1-3 working days",
    "没有缓存需要清空": "No cache needs to be cleared",
    "设置密码": "Set password",
    "提现金额小于最小提现金额": "The withdrawal amount is less than the minimum withdrawal amount",
    "提现金额大于最大提现金额": "The withdrawal amount is greater than the maximum withdrawal amount",
    "登录成功": "Login successful",
    "欢迎加入，请登录\/注册享超值优惠！": "Welcome to join, please log in\/register to enjoy great discounts!",
    "收藏成功": "Collection successful",
    "移除成功": "Removal successful",
    "取消收藏成功": "Cancel collection successful",
    "您还没有登录，请先登录": "You haven't logged in yet, please log in first",
    "取消关注成功": "Unsullowed successfully",
    "取消点赞成功": "Cancel like successful",
    "确定收货成功": "Confirm successful receipt of goods",
    "开票成功": "Invoice successful",
    "提醒成功": "Reminder successful",
    "收货成功": "Received successfully",
    "暂无可用优惠卷": "There are currently no available discount coupons available",
    "设置成功": "Set successfully",
    "还未绑定微信，请先绑定微信": "Not yet bound to WeChat, please bind to WeChat first",
    "还未绑定支付宝，请先绑定支付宝": "Alipay has not been bound, please bind Alipay first",
    "还未绑定银行卡，请先绑定银行卡": "Bank card not yet bound, please bind bank card first",
    "余额不足，请重新输入金额": "Insufficient balance, please re-enter the amount",
    "银行卡绑定成功": "Bank card successfully bound",
    "支付宝绑定成功": "Alipay binding succeeded",
    "微信绑定成功": "WeChat binding successful",
    "添加成功": "Successfully added",
    "编辑成功": "Edit successful",
    "昵称不能包含特殊字符": "Nicknames cannot contain special characters",
    "抽奖次数不足": "Insufficient number of lucky draws",
    "您已经参加此拼单": "You have already participated in this group order",
    "拉黑成功": "Successfully blacklisted",
    "请阅读并勾选": "Please read and check",
    "抽奖正在进行中": "The lottery is currently in progress",
    "请输入正确的公司税号": "Please enter the correct company tax number",
    "提交审核成功": "Successfully submitted for review",
    "未关注": "Not following",
    "继续抽奖": "Continue the lottery",
    "首发新品": "First release of new products",
    "最新出炉": "Latest furnace release",
    "开启定位权限，获取附近商家": "Enable location permission to obtain nearby merchants",
    "请添加收货地址": "Please add a shipping address",
    "请输入正确的确认新密码（6~12位字母+数字）": "Please enter the correct confirmation new password (6-12 letters+numbers)",
    "请输入正确的新手机号": "Please enter the correct new phone number",
    "您的还没登录，快去登录吧": "You haven't logged in yet, go and log in now",
    "编辑资料": "Editing Information",
    "有": "have",
    "篇笔记待发布": "Notes to be published",
    "草稿在应用卸载后会被删除，请及时发布": "The draft will be deleted after uninstalling the application. Please publish it in a timely manner",
    "切换语言": "switch language",
    "选择语言": "Choose language",
    "个人信息": "personal information",
    "联系人姓名": "Contact Name",
    "联系人手机": "Cell Phone ",
    "联系人身份证": "Contact ID",
    "打款备注": "Payment remarks",
    "银行信息": "Bank information",
    "结算支付宝账户": "Settle Alipay account",
    "支付宝收款二维码": "Alipay collection QR code",
    "开店套餐": "Store opening package",
    "店铺类型": "Store type",
    "简介": "brief introduction",
    "店铺所在位置": "Store location",
    "详细地址": "Detailed address",
    "重新入驻": "Re settle",
    "已选择发票": "Invoice selected",
    "暂无可用优惠劵": "There are currently no available coupons available",
    "请输入6位数的密码": "Please enter a 6-digit password",
    "请输入正确的充值金额": "Please enter the correct recharge amount",
    "请输入正确的提现金额": "Please enter the correct withdrawal amount",
    "实付金额：": "Actual payment amount:",
    "收款二维码": "Payment QR code",
    "请填写详细地址：如道路、门牌号、小区、楼栋号等": "Please provide detailed address, such as road, house number, community, building number, etc",
    "退款退货": "Refunds and Returns",
    "是否撤销售后？": "Do you want to cancel the after-sales service?",
    "砍价": "Bargaining",
    "驳回原因：": "Reason for rejection:",
    "直推": "Direct push",
  
  
    "请输入用户名": "Please enter your username",
    "请输入新密码(6~12位字母+数字)": "Password (6~12 letters+numbers)",
    "请求错误(400)": "Request error (400)",
    "未授权，请重新登录(401)": "Unauthorized, please login again (401)",
    "登录失效": "Login failure",
    "拒绝访问(403)": "Access Denied (403)",
    "请求出错(404)": "Request error (404)",
    "请求超时(408)": "Request timeout (408)",
    "服务器错误(500)": "Server Error (500)",
    "服务未实现(501)": "Service not realized (501)",
    "网络错误(502)": "Network error (502)",
    "服务不可用(503)": "Service Unavailable (503)",
    "网络超时(504)": "Network timeout (504)",
    "HTTP版本不受支持(505)": "HTTP version not supported (505)",
    "服务器错误!": "Server error!",
    "服务器太拥挤了~请您稍后重试": "The server is too crowded ~ Please try again later",
    "登录失效，请重新登录": "Login failed, please login again",
    "刚刚": "Just now",
    "分钟前": "A minute ago",
    "小时前": "Hours ago",
    "天前": "Days ago",
    "个月前": "A month ago",
    "年前": "Before the New Year",
    "请先设置你的密码": "Please set your password first",
    "要携带的参数": "Parameters to carry",
    "请用指纹解锁": "Please use your fingerprint to unlock",
    "验证失败": "Verification failure",
    "请用FaceID解锁": "Please use FaceID to unlock",
    "识别成功": "Identify success",
    "首页": "Home",
    "分类": "Sort",
    "购物车": "Shopping cart",
    "我的": "Mine",
    "操作成功~": "Operation successful ~",
    "支付失败": "Payment failure",
    "上传中": "Up cross",
    "上传失败，请重试": "Upload failed, please try again",
    "视频上传失败，请重试": "Video upload failed, please try again",
    "图片上传失败，请重试": "Image upload failed, please try again",
    "通知权限开启提醒": "Notification Permission Enable alerts",
    "您还没有开启通知权限，无法接受到消息通知，是否前往设置？": "You have not enabled notification rights and cannot receive message notifications. Do you want to go to Settings?",
    "直播": "Live broadcast",
    "验证码发送成功": "The verification code is sent successfully. Procedure",
    "请输入手机号": "Please enter your phone number",
    "请正确输入手机号": "Please enter your phone number correctly",
    "请发送验证码": "Please send the verification code",
    "后重新获取": "Reacquire after",
    "提示": "Tips",
    "确定要清除本地缓存？": "Sure you want to clear the local cache?",
    "缓存清理完成!": "Cache cleanup complete!",
    "取消支付": "Cancel payment",
    "支付失败,请稍后重试": "Payment failed, please try again later",
    "请输入账号": "Please enter your account number",
    "请正确账号": "Please correct the account number",
    "发送中...": "Sending...",
    "您有逾期订单未还款，请先还款": "You have overdue orders, please repay first",
    "确定删除该评论": "Confirm to delete the comment",
    "可前往至“我的优惠券“中心查看": "Check out the \"My Coupons\" center",
    "确定删除该提货人?": "Are you sure to delete the shipper?",
    "审核被拒绝，请重新提交": "Review rejected, please resubmit",
    "发现新版本": "Discover new version",
    "下次再说": "Talk to you next time",
    "马上更新": "Update now",
    "已是最新版本": "This is the latest version",
    "已准备好新版本,是否重启体验新版?": "The new version is ready. Do you want to restart the new version?",
    "重启": "Restart",
    "取消下载": "Cancel download",
    "下载失败": "Download failure",
    "搜索": "search",
    "定位\/最近访问": "Location\/Recently accessed",
    "月": "month",
    "年": "years",
    "开始": "initiate",
    "结束": "finish",
    "日": "day",
    "一": "one.",
    "二": "two.",
    "三": "three",
    "四": "four",
    "五": "five",
    "六": "six",
    "星期日": "Sunday.",
    "星期一": "Monday.",
    "星期二": "Tuesday.",
    "星期三": "Wednesday.",
    "星期四": "Thursday.",
    "星期五": "Friday.",
    "星期六": "Saturday.",
    "加载中": "Loading",
    "已加载全部数据": "All data has been loaded",
    "暂无数据": "No data available",
    "销量": "Sales volume",
    "万": "wan",
    "加载失败": "Load failure",
    "加载中...": "Loading...",
    "已有账号？去": "Existing account? go",
    "温馨提示": "Warm reminder",
    "请输入内容~": "Please enter the content ~",
    "取消": "Cancel",
    "确认": "verify",
    "返回": "Back",
    "请再次确认,你已了解注销风险,并要继续执行该操作": "Please confirm again that you are aware of the cancellation risk and wish to continue with the operation",
    "请输入搜索关键字": "Please enter the search keyword",
    "标题": "title",
    "请检查网络，或者前往": "Please check the network or go to",
    "设置": "Settings",
    "点击刷新": "Click to refresh",
    "哎呀，网络信号丢失": "Oops, the network signal is lost",
    "网络链接成功": "Network connection successful",
    "无网络链接": "No network link",
    "分享到": "Share to",
    "微信好友": "Wechat friend",
    "二维码海报": "Qr code poster",
    "保存到相册": "Save to album",
    "保存图片": "Save picture",
    "朋友圈": "Circle of friends",
    "QQ空间": "qzone",
    "QQ好友": "QQ friend",
    "新浪微博": "Sina Weibo",
    "复制链接": "Copy link",
    "复制成功": "Successful replication",
    "分享失败": "Sharing failure",
    "海报生成中...": "Poster generation...",
    "获取头像信息失败": "Failed to obtain profile picture information. Procedure",
    "获取商品图片信息失败": "Failed to obtain product picture information",
    "推荐一个好物给你,请查收": "Recommend a good thing to you, please check",
    "获取二维码信息失败": "Failed to obtain QR code information. Procedure",
    "保存成功": "Save successfully",
    "为你推荐": "Recommend for you",
    "上拉显示更多": "Pull up to show more",
    "正在加载...": "Loading...",
    "没有更多数据了": "No more data",
    "该商品已售馨": "The article is sold out",
    "该商品最多能购买": "This item can be purchased at most",
    "件": "a",
    "商品详情": "Product details",
    "预售价": "Presale price",
    "定金": "Earnest money",
    "已收藏": "Have already collected",
    "收藏": "Collect",
    "内地": "Inland",
    "本地": "local",
    "最新": "Latest",
    "您的浏览器不支持 video 标签。": "Your browser does not support video tags.",
    "注您需要重置手机号请联系客服": "Please contact customer service to reset your phone number",
    "已取消拉黑": "Cancelled blacklisting",
    "微信号": "Wechat ID",
    "哈法看点": "Haffa watch",
    "入驻商家": "Settled merchant",
    "今日折扣": "Today's discount",
    "本地生活": "Local life",
    "二手交易": "Second-hand",
    "租房": "Renting",
    "二手车": "Used car",
    "招聘": "Recruit",
    "宠物": "Pet",
    "最新": "Latest",
    "哈哈镜头": "Ha ha shot",
    "消息": "message",
    "全款": "Full payment",
    "合租": "Joint tenancy",
    "整租": "Whole tenancy",
    "领养": "adopt",
    "本地": "This locality",
    "国内": "home",
    "发送": "send",
    "为你优选": "Choose for you",
    "网址": "website",
    "标签": "tag",
    "详情": "details",
    "关注": "follow",
    "复制": "copy",
    "评论": "review",
    "添加好友": "Add friends",
    "发现虚假信息，请立即举报！": "Find false information, please report immediately!",
    "展开更多评论": "Open more comments",
    "展开": "unfold",
    "回复": "recover",
    "条": "article",
    "咨询": "consult",
    "哈法惠生活": "Hafahui life",
    "折扣分享": "Discount sharing",
    "发布": "publish",
    "确定要删除选择的内容吗？": "Are you sure you want to delete the selected content?",
    "此操作将永久拉黑, 是否继续?": "This operation will permanently blackout. Do you want to continue?",
    "重置": "reset",
    "确定": "OK",
    "面积": "area",
    "户型": "House type",
    "房型": "House type",
    "地址": "address",
    "基本信息": "Basic information",
    "招聘详情": "Recruitment details",
    "为您推荐": "Recommend for you",
    "历史搜索": "History search",
    "暂无图片": "There are currently no pictures available",
    "确定删除历史记录？": "Are you sure to delete history?",
    "请输入想要搜索的内容": "Please enter what you want to search for",
    "粉丝": "vermicelli",
    "获赞": "Be praised",
    "职业：": "Class:",
    "请输入职业": "Please enter occupation",
    "入住时间": "Check-in Time",
    "已成功复制到剪贴板": "Successfully copied to clipboard",
    "该用户还没有填写签名": "The user has not signed",
    "该用户还没有填写签名…": "The user has not signed…",
    "帖子": "post",
    "官方发布": "Official release",
    "￥": "￥",
    "元": "yuan",
    "招聘类型：": "Recruitment Type:",
    "发布时间：": "Release time:",
    "举报": "report",
    "拉黑": "shield",
    "上传图片只能是 JPG, PNG 格式!": "Uploading images can only be in JPG, PNG format!",
    "上传头像图片大小不能超过 2MB!": "The size of the uploaded avatar image cannot exceed 2MB!",
    "由于该用户隐私设置，关注列表不可见": "Due to this user privacy setting, the follow list is not visible",
    "已关注": "Followed",
    "注册": "Sign in",
    "欢迎注册": "Welcome to register",
    "设置密码:": "Set password:",
    "推荐人：": "Referrer:",
    "请输入验证码": "Please enter the verification code",
    "立即注册": "Register now",
    "已阅读并同意": "Read and agree",
    "《用户注册协议》": "User Registration Agreement",
    "《隐私政策》": "Privacy Policy",
    "与": "with",
    "下载": "Download",
    "iPhone下载": "iPhone download",
    "Android下载": "Android download",
    "请选择举报原因": "Please select the reason for reporting",
    "请填写举报理由": "Please fill in the report reason",
    "只能上传jpg/png文件,最多上传6张图片": "Only jpg/png files can be uploaded, with a maximum of 6 images uploaded",
    "最多输入300字（选填）": "Enter up to 300 words (optional)",
    "请上传应用截图，最多上传6张": "Please upload a maximum of 6 app screenshots",
    "提交": "submit",
    "提交成功": "Submit successfully",
    "返回首页": "Back to home page",
    "公告详情": "Announcement details",
    "请输入想要搜索的": "Please enter what you want to search for",
    "发帖": "Posting",
    "看帖排序": "Post ranking",
    "隐私与政策": "Privacy and Policy",
    "全部回复": "Reply all",
    "留下你的精彩回复吧 ": "留下你的精彩回复吧 ",
    "条回复": "Reply (s) with",
    "官方视频": "Official video",
    "发布中心": "Release center",
    "发布成功": "Release success",
    "发布成功，请在我的中进行查看": "Release success, please check in my",
    "查看我的发布": "Check out my post",
    "确认订单": "Confirm the order",
    "置顶天数": "Days on top",
    "置顶费用": "Top charge",
    "总计：￥": "Total: ￥",
    "提交订单": "Submit an order",
    "天": "day",
    "产品经理": "Product manager",
    "立即支付": "Immediate payment",
    "支付剩余时间：": "Payment remaining time:",
    "选择支付方式": "Select payment method",
    "支付结果": "Result of payment",
    "支付成功，已发布": "Payment successful, published",
    "支付方式：": "Payment method:",
    "支付时间：": "Payment Time:",
    "发布论坛": "Publishing forum",
    "发布分类": "Publication classification",
    "请输入发布标题": "Please enter the publication title",
    "说出你的心情": "Speak your mind",
    "发布签约作家需要平台进行审核 审核成功就发布成功。": "Publishing a signed writer requires a platform to review the success of the review.",
    "发布签约作家需要平台进行审核": "Publishing signed writers requires platform review",
    "审核成功就发布成功。": "If the review is successful, it will be published successfully.",
    "选择照片": "Select photo",
    "完成": "complete",
    "请选择发布分类": "Please select a publication category",
    "您还未进行认证，请前往进行认证；": "You are not yet certified, please go to the certification;",
    "发布入驻商家": "Publish settled merchants",
    "上传logo（只能上传1张）": "Upload logo (can only upload 1 photo)",
    "上传图片": "Upload pictures",
    "商家分类": "Merchant classification",
    "商家名称": "Merchant name",
    "请输入商家名称": "Please enter the business name",
    "请输入标题": "Please enter the title",
    "请输入网址": "Please enter the URL",
    "请输入地址": "Please enter the address",
    "请输入…": "Please enter...",
    "可多选": "Multiple choices",
    "我要置顶": "I want the top",
    "支付成功，平台审核中": "Payment successful, platform review",
    "发布入驻商家需要平台进行审核，审核成功就发布成功。审核未通过支付的置顶费用金额原路退回。": "Release the settled merchants need to be audited by the platform, and the success of the audit will be released successfully. The amount of the roof placement fee that has not been paid is returned to the original route.",
    "接机搬家": "Pick up and move",
    "清洁打扫": "Clean and sweep",
    "发布折扣": "Release discount",
    "最多上传": "Maximum upload",
    "张": "Photos",
    "内容将被丢弃，退出编辑？": "Content will be discarded, exit editing?",
    "继续编辑": "Continue",
    "发布本地生活": "Publish Local life",
    "请选择": "Please select",
    "顺风车": "Free ride",
    "有偿带物": "Paid carry-on",
    "教育": "education",
    "运动": "movement",
    "节日": "Festivals",
    "休闲娱乐": "Leisure and entertainment",
    "宗教活动": "Religious activity",
    "请上传图片，最多上传": "Please upload pictures, Max",
    "类型": "type",
    "求购": "Ask to buy",
    "出售": "Sell",
    "价格": "Price",
    "请输入价格": "Please enter price",
    "发布租房": "Release rental",
    "区域": "region",
    "租住类型": "Rental type",
    "房屋户型": "Housing type",
    "入驻时间": "Check-in time",
    "租金": "rent",
    "请输入租金如：3000元\/月": "Please enter the rent as follows: 3000 yuan\/month",
    "面议": "Discuss personally",
    "房屋面积": "Building area",
    "请输入房屋面积": "Please enter the size of the house",
    "详细地址": "Detailed address",
    "请输入详细地址": "Please enter the full address",
    "租房类型": "Rental type",
    "别墅": "villa",
    "公寓": "flat",
    "地区": "district",
    "安阳市": "Anyang City",
    "鹤壁市": "Hebi City",
    "济源市": "Jiyuan City",
    "焦作市": "Jiaozuo City",
    "开封市": "Kaifeng City",
    "许昌市": "Xuchang City",
    "郑州市": "The city of Zhengzhou",
    "1室": "Room 1",
    "0厅": "Zero hall",
    "0卫": "0 guard",
    "2室": "Room 2",
    "1厅": "1 hall",
    "1卫": "First guard",
    "3室": "Room 3",
    "2厅": "Concourse 2",
    "2卫": "Second guard",
    "4室": "Room 4",
    "3厅": "Concourse 3",
    "3卫": "Third guard",
    "5室": "Room 5",
    "4厅": "Hall 4",
    "选择日期": "Select date",
    "发布二手车": "Release used cars",
    "品牌": "brand",
    "请输入品牌": "Please enter brand",
    "车型": "Vehicle type",
    "请输入车型": "Please enter vehicle type",
    "年份": "A given year",
    "付款方式(多选)": "Payment method",
    "分期": "By stages",
    "公里数": "kilometres",
    "请输入公里数": "Please enter the mileage",
    "发布招聘": "Job Posting",
    "招聘类型": "Recruitment type",
    "请选择招聘类型": "Please select the recruitment type",
    "职位名称": "Job title",
    "请输入职位名称": "Please enter the job title",
    "请输入最低": "Minimum",
    "请输入最高": "Maximum",
    "工作地址": "Working address",
    "请输入工作地址": "Please enter your work address",
    "全职": "full-time",
    "兼职": "Part-time job",
    "钟点工": "Hourly worker",
    "发布宠物": "Release pets",
    "宠物分类": "Pet classification",
    "宠物物品": "Pet items",
    "宠物交友": "Pet dating",
    "我的消息": "My news",
    "新增关注": "New attention",
    "平台公告": "Platform announcement",
    "在线客服": "Online customer service",
    "好的，我知道了": "Ok, I see",
    "客服名称": "Customer service name",
    "已读": "read",
    "未读": "unread",
    "平台消息": "Platform message",
    "消息详情": "Message details",
    "个人主页": "Personal homepage",
    "我的发布": "My release",
    "审核中": "Under review",
    "已发布": "Have released",
    "历史记录": "Historical record",
    "我的功能": "My function",
    "商家认证": "Certification",
    "签约作家": "Contracted writer",
    "联系我们": "Contact us",
    "意见反馈": "Feedback",
    "平台认证": "Platform authentication",
    "通过平台认证的商家可以获得专属的金色标签并享有商家排序等级上升的专属功能。": "Merchants certified by the platform can get exclusive gold tags and enjoy the exclusive function of merchants ranking up.",
    "在哈法App就向与平台签约的作家支付稿费签约作家也可获得专属的金色标签。": "Writers who sign up to the platform are paid a fee on the Hafa App, and signed writers receive an exclusive gold tag.",
    "签约作家认证": "Signed author certification",
    "请填写真实的信息，我们将会保证您的信息安全": "Please fill in the true information, we will ensure your information security",
    "姓名": "name",
    "请输入法人姓名": "Please enter the legal person name",
    "电话号码": "Telephone number",
    "请输入电话号码": "Please enter the phone number",
    "邮箱号": "Email address",
    "请输入邮箱号": "Please enter your email number",
    "请输入微信号": "Please enter wechat",
    "请上传证件信息": "Please upload your ID information",
    "证件正面": "Front of certificate",
    "证件反面": "Back of certificate",
    "认证": "authentication",
    "收藏于：": "Collected in:",
    "发布中": "In release",
    "编辑": "EDITOR",
    "年 | 公里": "Year | km",
    "万km": "myrikm",
    "该信息置顶中，确定要编辑这个信息吗？编辑发布需要重新支付置顶费用哦~": "This information is at the top. Are you sure you want to edit this information? Editing and publishing need to pay the top fee again",
    "足迹": "footmark",
    "发布于：": "Posted on:",
    "审核未通过": "Fail the audit",
    "删除": "delete",
    "请选择要删除的足迹": "Please select the footprints to be deleted",
    "地址：": "Address:",
    "是否删除该内容": "Whether to delete the content",
    "报价": "offer",
    "现公里数": "Current mileage",
    "人关注": "Human attention",
    "留下你的精彩评论吧": "Leave your great comments",
    "法人姓名": "Corporate name",
    "公司名称": "Company name",
    "请输入公司名称": "Please enter the company name",
    "请输入": "Please enter",
    "营业执照": "Business license",
    "技能提交成功，平台审核通过将会点亮认证图标；": "If the skills are submitted successfully, the certification icon will be lit if the platform is approved;",
    "审核失败": "Audit failure",
    "重新申请": "reapply",
    "联系客服": "Contact customer service",
    "放弃申请": "Abandon the application",
    "我要反馈": "I want feedback.",
    "反馈类型": "Feedback type",
    "反馈内容": "Feedback content",
    "问题描述的越详细，有助于我们更快的解决问题": "The more detailed the problem description, the faster we can solve the problem",
    "反馈类型：": "Type of feedback:",
    "反馈时间：": "Feedback time:",
    "平台回复：": "Platform Reply:",
    "我关注的人": "People I pay attention to",
    "确定不在关注TA吗？": "Are you sure you're not paying attention?",
    "不在关注": "Pay no attention to",
    "我的粉丝": "My fans",
    "官网：": "Official Site:",
    "微信：": "Wechat:",
    "公司邮箱：": "Company Email:",
    "公司地址：": "Company Address:",
    "呼叫客服": "Call customer service",
    "我的资料": "My information",
    "头像": "avatar",
    "ID": "ID",
    "昵称": "nickname",
    "性别": "sex",
    "生日": "birthday",
    "职业": "occupation",
    "请输入签名": "Please enter your signature",
    "已认证": "authenticated",
    "签约合作认证": "Contract cooperation certification",
    "保存": "save",
    "证件号": "Id number",
    "修改头像": "Modify profile picture",
    "拍照": "Take a picture",
    "从手机相册选择": "Select from your phone album",
    "重新选择": "reselect",
    "选择性别": "Selective sex",
    "男": "male",
    "女": "female",
    "选择生日": "Choose a birthday",
    "账号与安全": "Account and security",
    "关于我们": "About us",
    "用户注册协议": "User registration protocol",
    "隐私协议": "Privacy agreement",
    "清除缓存": "Clear cache",
    "检查更新": "Check for updates",
    "退出登录": "Log out",
    "修改密码": "Change password",
    "修改绑定手机号": "Modify the bound mobile phone number",
    "通讯录黑名单": "Address book blacklist",
    "关注和粉丝列表": "Follow and fan list",
    "注销账号": "Cancel account",
    "移除": "Remove",
    "你确认要把用户该用户移除黑名单!": "你确认要把用户该用户移除黑名!",
    "旧密码验证修改": "Old password authentication changed",
    "手机号验证修改": "Mobile phone number verification modified",
    "旧密码：": "Old password:",
    "请输入旧密码": "Please enter your old password",
    "新密码：": "New password:",
    "请输入新密码": "Please enter your new password",
    "确认新密码：": "Confirm new password:",
    "请再次输入新密码": "Please enter your new password again",
    "完 成": "complete",
    "我们要对您绑定的手机号进行验证：": "We want to verify your mobile phone number:",
    "下一步": "next",
    "绑定新手机": "Bind a new phone",
    "新手机号码：": "New phone number:",
    "请输入新的手机号": "Please enter your new phone number",
    "短信验证：": "SMS verification:",
    "获取短信验证": "Get SMS verification",
    "填写注销申请": "Fill in an application for cancellation",
    "账号注销": "Account cancellation",
    "永久注销且无法恢复，请谨慎操作": "If you are permanently logged out and cannot be restored, exercise caution when performing this operation",
    "请选择注销原因": "Please select a reason for logout",
    "请输入~": "Please enter ~",
    "账号注销后将放弃以下权益：": "After account cancellation, the following rights and interests will be waived:",
    "我已清楚风险，确定继续": "I'm aware of the risks and determined to continue",
    "请再次确认，你已了解注销风险并要继续执行该操作": "Please reconfirm that you understand the logout risks and want to proceed",
    "注销申请提交成功！": "Deregistration application submitted successfully!",
    "我们工作人员将会对您的账号进行审核，审核通过后，账号将会被注销，请知悉": "Please note that our staff will review your account, and the account will be cancelled after the review",
    "处理中": "In process",
    "注销理由：": "Reasons for cancellation:",
    "设置初始密码": "Set initial password",
    "初始密码": "Initial password",
    "密码：": "Password:",
    "注册协议": "Registration agreement",
    "隐私政策": "Privacy Policy",
    "确定清理缓存？": "Are you sure to clear the cache?",
    "确定退出当前账号？": "Are you sure to log out of the current account?",
    "欢迎登录": "Welcome to login",
    "请输入密码（6-12位字母+数字）": "Please enter your password (6-12 characters + numbers)",
    "验证码登录": "Verification code login",
    "注册账号": "Register an account",
    "忘记密码": "Forgot password",
    "快捷登录": "Quick login",
    "请输入邀请码（选填）": "Please enter the invitation code (optional)",
    "已有账号": "Already have an account",
    "选择国家或地区": "Select a country or region",
    "选择国家/地区：": "Select country/region:",
    "选择国家/地区": "Select country/region",
    "密码登录": "Password login",
    "登录": "Log in",
    "微信登录": "Wechat login",
    "请使用微信扫描二维码登录": "Please use wechat to scan the QR code to log in",
    "绑定手机号": "Bind mobile phone number",
    "确认登录密码(6~12位数字+字母)": "Confirm the login password (6-12 digits + letters)",
    "微信号：": "Wechat ID:",
    "马上登录": "Log in now",
    "更新日期": "Update date",
    "请输入想要搜索信息": "Please enter the information you want to search",
    "扫码下载APP": "Download APP",
    "IOS": "IOS",
    "小程序": "Small program",
    "在线咨询": "Online consultation",
    "热线电话：": "Hotline:",
    "Hi，您还没有进行登录请前往进行登录": "Hi, you have not logged in yet please go to log in",
    "已选条件": "Selected condition",
    "分类": "classify",
    "清除筛选": "Clear filter",
    "更多": "more",
    "共": "A total of",
    "每页": "Each page",
    "前往": "go",
    "页": "page",
    "举报内容": "Report content",
    "我的关注": "My attention",
    "审核未通过支付的置顶费用金额原路退回。": "The amount of the top fee that has not been approved for payment will be refunded through the original payment method.",
    "发布入驻商家需要平台进行审核，审核成功就发布成功。": "The platform needs to conduct a review to publish merchants who have joined the platform. If the review is successful, the publication will be successful.",
    "私信": "Message",
    "分享": "Share",
    "全部评论": "All comments",
    "收起回复": "Drop reply",
    "回复愤怒的小鸟:": "Reply to Angry Birds:",
    "发表": "publish",
    "论坛列表": "List of forums",
    "论坛详情": "Forum Details",
    "商家名称：": "Business Name:",
    "网址：": "Website:",
    "租住：": "Rental:",
    "地区：": "Region:",
    "用户昵称": "User nickname",
    "付款方式：": "Payment method:",
    "工作地址：": "Work address:",
    "订单金额：¥": "Order amount: $",
    "确定删除该条评论；": "Make sure to delete the comment;",
    "选择类型": "Select type",
    "填写内容": "Fill in the content",
    "发布-今日折扣": "Release - Today's discount",
    "结算": "Settle an account",
    "置顶": "Pinned",
    "置顶信息": "Top information",
    "小计": "subtotal",
    "总额：": "Total amount:",
    "应付总额：": "Total payable:",
    "发布-租房": "Release - Rent",
    "发布-宠物": "Release - Pets",
    "发布-招聘": "Release - Recruitment",
    "发布-二手车": "Release - Used Cars",
    "发布-二手交易": "Release - Second hand transactions",
    "发布-本地生活": "Release - Local Life",
    "收银台": "checkstand.",
    "订单提交成功，请尽快付款！订单号：": "Order submitted successfully, please make payment as soon as possible! Order number:",
    "订单提交成功，请尽快付款！": "Order submitted successfully, please pay as soon as possible!",
    "订单号：": "Order Number:",
    "请您在": "Could you please",
    "内完成支付，否则订单会被自动取消": "Complete the payment within, otherwise the order will be automatically cancelled",
    "应付金额": "Amount payable",
    "打开手机 微信扫一扫继续付款": "Open the mobile phone wechat scan to continue the payment",
    "订单金额：": "Order amount:",
    "发布分类：": "Release category:",
    "标题：": "Title:",
    "图片：": "Photos:",
    "点击上传": "Upload",
    "详情：": "Details:",
    "富文本框；有图有文字": "Rich text box; There are pictures and words",
    "论坛发布": "Forum release",
    "您还未进行认证，请前往认证；": "You have not yet been certified, please go to the certification;",
    "上传图片（最多9张）：": "Upload pictures:",
    "商家分类：": "Merchant category:",
    "请输入详情": "Please enter details",
    "标签（可多选）：": "Tags (multiple options) :",
    "我要置顶：": "I want to top:",
    "发布-入驻商家": "Release - Settled merchants",
    "区域：": "Area:",
    "请选择区域": "Please select a region",
    "租住类型：": "Rental Type:",
    "房型：": "Room Type:",
    "请输入租金如:$3000/月": "Please enter the rent",
    "房屋户型：": "Housing type:",
    "请选择几室": "Please select which rooms",
    "请选择几厅": "Please select which hall",
    "请选择几卫": "Please select which guard",
    "入驻时间：": "Check-in Time:",
    "请选择入驻时间": "Please select check-in time",
    "租金：": "Rent:",
    "房屋面积：": "House size:",
    "详细地址：": "Detailed address:",
    "品牌：": "Brand:",
    "车型：": "Model:",
    "年份：": "Year:",
    "请选择年份": "Please select a year",
    "付款方式（多选）：": "Payment method:",
    "公里数：": "Kilometers:",
    "职位名称：": "Job Title:",
    "薪资待遇：": "Salary:",
    "薪资待遇": "Salary",
    "请输入薪资待遇": "Please enter salary",
    "用户中心": "User center",
    "个人资料": "Personal data",
    "账户密码": "Account password",
    "关注\/粉丝": "Followers\/fans",
    "黑名单": "Blacklist",
    "通过平台认证的商家可以获得专属的金色标签 并享有商家排序等级上升的专属功能。": "Merchants certified by the platform can get exclusive gold tags and enjoy the exclusive function of merchants ranking up.",
    "在哈法App就向与平台签约的作家支付稿费 签约作家也可获得专属的金色标签。": "Writers who sign up to the platform are paid a fee on the Hafa App, and signed writers receive an exclusive gold tag.",
    "我的私信": "My private message",
    "查看全部私信": "View all private messages",
    "通知": "notification",
    "关注了你": "I followed you",
    "回复您：": "Reply to you:",
    "平台发布了通知": "The platform has issued a notice",
    "查看全部关注": "View all followers",
    "查看全部通知": "View all notifications",
    "查看全部收藏": "View all Favorites",
    "收藏了你的": "Collected your",
    "头像：": "Avatar:",
    "开始关注了你": "I started following you",
    "回复了您：": "I replied to you:",
    "通知中心": "Notification center",
    "你确认要把该用户移除黑名单!": "Are you sure you want to remove the user from the blacklist!",
    "信息": "Message",
    "操作": "Controls",
    "该信息置顶中，确定要编辑这个信息吗？编辑发布需要 重新支付置顶费用哦~": "This information is at the top. Are you sure you want to edit this information? Editing and publishing need to pay the top fee again",
    "您的意见是我们前进的动力": "Your opinion is our driving force",
    "请输入您的意见或反馈": "Please enter your comments or feedback",
    "昵称：": "Nickname:",
    "ID：": "ID：",
    "性别：": "Gender:",
    "未认证": "Unauthenticated",
    "生日：": "Date of Birth:",
    "签名：": "Signature:",
    "商家认证：": "Merchant certification:",
    "签约作家：": "Signed writers:",
    "法人姓名：": "Legal person Name:",
    "电话号码：": "Phone Number:",
    "电话：": "Phone Number:",
    "公司名称：": "Company Name:",
    "请上传公司相关信息": "Please upload company information",
    "证件正面：": "Front of the certificate:",
    "营业执照：": "Business License:",
    "邮箱号：": "Email Number:",
    "公司营业执照需加盖公章上传，否则审核不通过": "The company's business license needs to be uploaded with the official seal, otherwise the audit will not pass",
    "证件反面：": "Back of certificate:",
    "提交认证": "Submit for certification",
    "技能提交成功，平台审核通过将会点亮技能图标；": "Skills submitted successfully, the platform approved the skills icon will be lit;",
    "姓名：": "Name:",
    "请输入姓名": "Please enter your name",
    "账号密码": "Account password",
    "发送内容不能为空!": "The content sent cannot be empty!",
    "填写注销消息":"Fill in cancellation message",
    "绑定手机：您已绑定手机：": "Bound phone: You have bound phone:",
    "，若手机丢失或停用，请及时更换": "If the phone is lost or disabled, please replace it in time",
    "修改": "edit",
    "登录密码：联网帐号存在被盗风险，定期更改密码已保护帐户安全": "Login password: Network accounts are at risk of theft. Periodically changing passwords protects account security",
    "注销账号：注销账号所有信息将被删除，账号不能进行登录": "Log out of the account: After you log out of the account, all information will be deleted and the account cannot be used to log in",
    "关注和粉丝列表：隐私设置关闭别人将不能查看关注和粉丝列表": "Following and fan list: With privacy Settings off, others will not be able to view the following and fan list",
    "可见": "visible",
    "填写注销信息": "Fill in the logout information",
    "请填写注销账号理由": "Please fill in the reason for account cancellation",
    "账号注销后将放弃以下权益原因：": "The following reasons will be waived after account cancellation:",
    "点击下方按钮，即表示你已阅读并了解以上风险": "By clicking the button below, you have read and understood the risks above",
    "请再次确认，你已了解注销风险，并要继续执行该操作": "Please reconfirm that you understand the logout risks and want to proceed with this action",
    "更换新手机号": "Get a new phone number",
    "当前手机号码：": "Current mobile phone number:",
    "图形验证码：": "Graphic verification code:",
    "换张图": "Change sheet",
    "短信验证码：": "SMS verification code:",
    "温馨提醒": "Warm reminder",
    "若有疑问请联系在线客服或拨打": "Warm remiIf you have any questions, please contact online customer service or callnder",
    "为保障您的帐号安全，变更重要信息需要短信验证": "To ensure the security of your account, change important information requires SMS verification",
    "若有疑问请联系在线客服或拨打400-000-0000": "If you have any questions, please contact the online customer service or call 400-000-0000",
    "修改登录密码": "Changing the Login Password",
    "验证码：": "Verification code:",
    "设置密码：": "Set password:",
    "请输入密码": "Please enter password",
    "确认密码：": "Confirm password:",
    "请再次输入密码": "Please enter your password again",
    "请再次输入密码!": "Please enter your password again!",
    "设置完成": "Setup complete",
    "选择语言": "Select language",
    "请输入用户名": "Please enter your username",
    "留下你的精彩回复吧": "Leave your wonderful reply",
    "你确认要把用户该用户移除黑名!": "You confirm to remove the user's black name!",
    "一卡通": "one-card",
    "\/月": "\/month",
    "请选择发布分类": "Please select category",
    "退出": "Out",
    "请输入租金如：$3000/月": "Please enter",
    "入住时间": "Check-in time",
    "入住时间：": "Check-in time：",
    "公里": "kilometre",
      "请输入手机号\/ID号": "Please enter the phone number \/ID number",
      "手机号\/ID号只能是数字": "The phone number \/ID number can only be a number",
      "请输入评论": "Please enter a comment",
      "没有筛选项": "No filter",
      "请选择举报类型": "Please select a report type",
      "请输入6-12位密码": "Please enter a 6-12 digit password",
      "验证码不能为空": "The verification code cannot be empty",
      "请安装微信后再使用此功能": "Please install wechat before using this function",
      "密码格式错误": "Password format error",
      "账号格式错误": "Account format error",
      "验证码格式错误": "The verification code format is incorrect",
      "请勾选用户协议": "Please check the User Agreement",
      "手机号不能为空": "The phone number cannot be empty",
      "手机号格式错误": "The phone number format is incorrect",
      "密码不能为空": "The password cannot be empty",
      "请输入验证码": "Please enter the verification code",
      "请输入密码": "Please enter password",
      "请上传图片": "Please upload pictures",
      "请填写标题": "Please fill in the title",
      "请填写详情": "Please fill in details",
      "请选择分类": "Please select category",
      "请选择招聘分类": "Please select a recruitment category",
      "请填写职位名称": "Please fill in the job title",
      "请选择新职待遇": "Please select new job offer",
      "请选择区域": "Please select a region",
      "请填写内容": "Please fill in the content",
      "请选择房型": "Please select room type",
      "请选择租住类型": "Please select the rental type",
      "请选择房屋户型": "Please select a house type",
      "请选择入驻时间": "Please select check-in time",
      "请选择付款类型": "Please select a payment type",
      "请选择商家分类": "Please select a merchant category",
      "请填写商家名称": "Please fill in the merchant name",
      "请填写品牌": "Please fill in the brand",
      "请填写车型": "Please fill in the model",
      "请选择年份": "Please select a year",
      "请选择付款方式": "Please select a payment method",
      "请选择价格方式": "Please select a price method",
      "请填写公里数": "Please fill in the mileage",
      "不吸烟": "Non smoking",
      "独立屋": "Independent housing",
      "室": "room",
      "卫": "Wei",
      "厅": "office",
      "类型：": "Type:",
      "请选择交易类型": "Please select a transaction type",
      "上传logo（只能上传1张）：": "Upload logo (only one can be uploaded):",
      "请选择标签": "Please select tag",
      "请填写姓名": "Please fill in your name",
      "请填写手机号": "Please fill in your mobile phone number",
      "请填写正确的邮箱": "Please fill in the correct email address",
      "请填写微信号": "Please fill in the wechat ID",
      "请输入证件号": "Please enter the ID number",
      "请上传身份证正面": "Please upload the front of your ID card",
      "请上传身份证反面": "Please upload the reverse side of your ID card",
      "请选择反馈类型": "Please select a feedback type",
      "请填写反馈内容": "Please fill in the feedback",
      "反馈成功": "Feedback success",
      "请上传证件反面": "Please upload the back of the identification document",
      "请上传证件正面": "Please upload the front of the identification document",
      "手机号输入有误": "Phone number input error",
      "请填写法人姓名": "Please fill in the legal person's name",
      "请填写电话号码": "Please fill in the phone number",
      "请填写证件号": "Please fill in the ID number",
      "请填写公司名称": "Please fill in the company name",
      "请填写详细地址": "Please fill in the full address",
      "请上传营业执照": "Please upload business license",
      "请选择注销原因": "Please select a reason for logout",
      "两次输入密码不一致!": "The two passwords are inconsistent!",
      "手机号格式不正确": "The format of the mobile phone number is incorrect",
      "两次输入的密码不一致": "The two passwords are different",
      "旧密码格式错误": "The old password format is incorrect",
      "设置登录密码(6-12位字母+数字)":"Set the login password (6 to 12 digits + letters)",


      "用户名不能为空":"The user name cannot be empty",
      "用户名1-20位":"The user name contains 1 to 20 characters",
      "密码不能为空":"The password cannot be empty",
      "密码1-20位":"Password 1-20 characters",
      "最新视频":"Latest video",
      "平台审核通过将会点亮技能图标":"A skill icon will light up if the platform is approved",
      "顶部":"Top",
      "吐槽":"Ridicule",
      "生活":"live",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",
      "用户名不能为空":"用户名不能为空",





}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js